// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client'
import { client } from './client.gen'
import {
  backgroundTasksTasksRetrieveResponseTransformer,
  directoutreachBetanxtVoterPolicySnapshotExportCreateResponseTransformer,
  directoutreachPolicyAvailableListResponseTransformer,
  directoutreachPolicyAvailableRetrieveResponseTransformer,
  directoutreachPolicyCreateResponseTransformer,
  directoutreachVotersCreateCreateResponseTransformer,
  directoutreachVotersHoldingsRetrieveResponseTransformer,
  directoutreachVotersSelectedPolicyCreateResponseTransformer,
  directoutreachVotersSelectedPolicyRetrieveResponseTransformer,
  directvotingBallotsCastVoteCreateResponseTransformer,
  directvotingBallotsProposalsRetrieveResponseTransformer,
  directvotingBallotsSearchCreateResponseTransformer,
  directvotingBallotStampsRetrieveResponseTransformer,
  directvotingBallotStampsSearchCreateResponseTransformer,
  directvotingBallotWorkflowItemsCreateResponseTransformer,
  directvotingBallotWorkflowItemsPartialUpdateResponseTransformer,
  directvotingBallotWorkflowItemsRetrieveResponseTransformer,
  directvotingBallotWorkflowItemsSearchCreateResponseTransformer,
  directvotingBeaconRuleOutputsCreateResponseTransformer,
  directvotingBeaconRuleOutputsRetrieveResponseTransformer,
  directvotingBeaconRuleOutputsSearchCreateResponseTransformer,
  directvotingCustodyAccountGroupMembershipsCreateResponseTransformer,
  directvotingCustodyAccountGroupMembershipsSearchCreateResponseTransformer,
  directvotingCustodyAccountGroupsCreateResponseTransformer,
  directvotingCustodyAccountGroupsPartialUpdateResponseTransformer,
  directvotingCustodyAccountGroupsRetrieveResponseTransformer,
  directvotingCustodyAccountGroupsSearchCreateResponseTransformer,
  directvotingCustodyAccountGroupsUpdateResponseTransformer,
  directvotingCustodyAccountTenantLinksLinkCreateResponseTransformer,
  directvotingCustodyAccountTenantLinksListResponseTransformer,
  directvotingCustodyAccountVotingPolicySelectionsCreateResponseTransformer,
  directvotingCustodyAccountVotingPolicySelectionsPartialUpdateResponseTransformer,
  directvotingCustodyAccountVotingPolicySelectionsRetrieveResponseTransformer,
  directvotingCustodyAccountVotingPolicySelectionsSearchCreateResponseTransformer,
  directvotingCustodyAccountVotingPolicySelectionsUpdateResponseTransformer,
  directvotingMeetingsAssignmentSearchCreateResponseTransformer,
  directvotingMeetingsSearchCreateResponseTransformer,
  directvotingRulesEngineRulesCreateResponseTransformer,
  directvotingRulesEngineRulesListsCreateResponseTransformer,
  directvotingRulesEngineRulesListsPartialUpdateResponseTransformer,
  directvotingRulesEngineRulesListsRetrieveResponseTransformer,
  directvotingRulesEngineRulesListsSearchCreateResponseTransformer,
  directvotingRulesEngineRulesPartialUpdateResponseTransformer,
  directvotingRulesEngineRulesRetrieveResponseTransformer,
  directvotingRulesEngineRulesSearchCreateResponseTransformer,
  directvotingWatchlistItemsBatchCreateResponseTransformer,
  directvotingWatchlistItemsCreateResponseTransformer,
  directvotingWatchlistItemsRetrieveResponseTransformer,
  directvotingWatchlistItemsSearchCreateResponseTransformer,
  directvotingWatchlistsCreateResponseTransformer,
  directvotingWatchlistsPartialUpdateResponseTransformer,
  directvotingWatchlistsRetrieveResponseTransformer,
  directvotingWatchlistsSearchCreateResponseTransformer,
  fundManagerFundManagersCreateResponseTransformer,
  fundManagerFundManagersPoliciesCreateResponseTransformer,
  fundManagerFundManagersPoliciesRetrieveResponseTransformer,
  fundManagerFundManagersRetrieveResponseTransformer,
  fundManagerFundManagersSearchCreateResponseTransformer,
  fundManagerFundManagersUpdateResponseTransformer,
  fundManagerFundsCreateResponseTransformer,
  fundManagerFundsQuantificationSnapshotsCreateResponseTransformer,
  fundManagerFundsRetrieveResponseTransformer,
  fundManagerFundsSearchCreateResponseTransformer,
  fundManagerFundsUpdateResponseTransformer,
  fundManagerFundVariantsCreateResponseTransformer,
  fundManagerFundVariantsRetrieveResponseTransformer,
  fundManagerFundVariantsSearchCreateResponseTransformer,
  fundManagerFundVariantsUpdateResponseTransformer,
  fundManagerProvidersCreateResponseTransformer,
  fundManagerProvidersListResponseTransformer,
  fundManagerProvidersRetrieveResponseTransformer,
  fundManagerProvidersUpdateResponseTransformer,
  fundManagerPublicSecurityIdsCreateResponseTransformer,
  fundManagerPublicSecurityIdsSearchCreateResponseTransformer,
  fundManagerQuantificationSnapshotsSearchCreateResponseTransformer,
  institutionalMeetingsearchListResponseTransformer,
  issuerFiscalYearsSearchCreateResponseTransformer,
  issuerInstrumentsOutstandingSharesRetrieveResponseTransformer,
  issuerInstrumentsRetrieveResponseTransformer,
  issuerInstrumentsSearchCreateResponseTransformer,
  issuerInstrumentsTotalShareholderReturnRetrieveResponseTransformer,
  issuerIssuersMarketCapitalisationRetrieveResponseTransformer,
  issuerIssuersRetrieveResponseTransformer,
  issuerIssuersSearchCreateResponseTransformer,
  proxyIntermediaryBallotsFetchByVersionIdsCreateResponseTransformer,
  proxyIntermediaryBallotsProxymityStaleProposalSetListResponseTransformer,
  proxyIntermediaryBallotsSearchCreateResponseTransformer,
  proxyIntermediaryBallotsUpsertCreateResponseTransformer,
  proxyIntermediaryBallotsVersionsListResponseTransformer,
  proxyIntermediaryCustodyAccountsCreateResponseTransformer,
  proxyIntermediaryCustodyAccountsPartialUpdateResponseTransformer,
  proxyIntermediaryCustodyAccountsRetrieveResponseTransformer,
  proxyIntermediaryCustodyAccountsSearchCreateResponseTransformer,
  proxyIntermediaryCustodyAccountsUpdateResponseTransformer,
  proxyIntermediaryProposalsCreateCreateResponseTransformer,
  proxyIntermediaryProposalsSearchCreateResponseTransformer,
  proxyIntermediaryProxyedgeVotesCreateCreateResponseTransformer,
  proxyIntermediaryProxyedgeVotesFetchLatestCreateResponseTransformer,
  proxyIntermediaryProxyIntermediariesSearchCreateResponseTransformer,
  proxyIntermediaryProxyIntermediaryMeetingsAuditEventsSearchCreateResponseTransformer,
  proxyIntermediaryProxyIntermediaryMeetingsCancelCreateResponseTransformer,
  proxyIntermediaryProxyIntermediaryMeetingsLinkTransparencyGeneralMeetingCreateResponseTransformer,
  proxyIntermediaryProxyIntermediaryMeetingsSearchCreateResponseTransformer,
  proxyIntermediaryProxyIntermediaryMeetingsUnlinkTransparencyGeneralMeetingCreateResponseTransformer,
  proxyIntermediaryProxyIntermediaryMeetingsUpsertCreateResponseTransformer,
  proxyIntermediaryProxymityVotesCreateCreateResponseTransformer,
  proxyIntermediaryProxymityVotesFetchLatestCreateResponseTransformer,
  proxyIntermediaryVoteStatusesUpsertCreateResponseTransformer,
  proxyvotingEntitlementsListResponseTransformer,
  proxyvotingFundManagerPolicySupportedIssuedInstrumentsCreateResponseTransformer,
  proxyvotingFundManagerPolicySupportedIssuedInstrumentsSearchCreateResponseTransformer,
  proxyvotingFundManagerSupportedPoliciesCreateResponseTransformer,
  proxyvotingFundManagerSupportedPoliciesListResponseTransformer,
  proxyvotingInvestorCompositionsDifferenceListResponseTransformer,
  proxyvotingInvestorCompositionsRulesEngineRetrieveResponseTransformer,
  proxyvotingInvestorCompositionsRulesEngineUpdateResponseTransformer,
  proxyvotingInvestorPolicySupportedIssuedInstrumentsCreateResponseTransformer,
  proxyvotingInvestorPolicySupportedIssuedInstrumentsSearchCreateResponseTransformer,
  proxyvotingInvestorSupportedIssuedInstrumentsCreateResponseTransformer,
  proxyvotingInvestorSupportedIssuedInstrumentsSearchCreateResponseTransformer,
  proxyvotingMeetingBallotsListResponseTransformer,
  proxyvotingMeetingBallotSourcesListResponseTransformer,
  proxyvotingPiballotsFilterListResponseTransformer,
  proxyvotingPimeetingsFilterListResponseTransformer,
  proxyvotingRulesEngineDefinitionsCreateResponseTransformer,
  proxyvotingRulesEngineDefinitionsListResponseTransformer,
  proxyvotingRulesEngineDefinitionsRetrieveResponseTransformer,
  proxyvotingRulesEngineDefinitionsRulesCreateResponseTransformer,
  proxyvotingRulesEngineDefinitionsRulesListResponseTransformer,
  proxyvotingRulesEngineDefinitionsRulesUpdateResponseTransformer,
  proxyvotingSviProposalOverwriteCreateResponseTransformer,
  proxyvotingSviSubmitVoteCreateResponseTransformer,
  tenancyPermissionGroupsCreateResponseTransformer,
  tenancyPermissionGroupsUpdateResponseTransformer,
  tenancyRolesCreateResponseTransformer,
  tenancyRolesPartialUpdateResponseTransformer,
  tenancyRolesRetrieveResponseTransformer,
  tenancyRolesSearchCreateResponseTransformer,
  tenancyRolesUpdateResponseTransformer,
  tenancyTenantsCreateResponseTransformer,
  tenancyTenantsRetrieveResponseTransformer,
  tenancyTenantsSearchCreateResponseTransformer,
  tenancyTenantsUpdateResponseTransformer,
  tenancyUsersCreateResponseTransformer,
  tenancyUsersRetrieveResponseTransformer,
  tenancyUsersSearchCreateResponseTransformer,
  tenancyUsersUpdateResponseTransformer,
  transparencyAuditEventsSearchCreateResponseTransformer,
  transparencyExternalMeetingIdsCreateResponseTransformer,
  transparencyGeneralMeetingsCreateResponseTransformer,
  transparencyGeneralMeetingsPartialUpdateResponseTransformer,
  transparencyGeneralMeetingsRetrieveResponseTransformer,
  transparencyGeneralMeetingsSearchCreateResponseTransformer,
  transparencyOrganizationsCreateResponseTransformer,
  transparencyOrganizationsGeneralMeetingsProposalsCreateResponseTransformer,
  transparencyOrganizationsGeneralMeetingsProposalsPartialUpdateResponseTransformer,
  transparencyOrganizationsGeneralMeetingsProposalsRetrieveResponseTransformer,
  transparencyOrganizationsGeneralMeetingsProposalsSearchCreateResponseTransformer,
  transparencyOrganizationsGeneralMeetingsProposalsUpdateResponseTransformer,
  transparencyOrganizationsGetByIdentifierCreateResponseTransformer,
  transparencyOrganizationsLogoCreateResponseTransformer,
  transparencyOrganizationsPartialUpdateResponseTransformer,
  transparencyOrganizationsRetrieveResponseTransformer,
  transparencyOrganizationsSearchCreateResponseTransformer,
  transparencyOrganizationsUpdateResponseTransformer,
  transparencyProposalsFetchCreateResponseTransformer,
  transparencyPublicSecurityIdsSearchCreateResponseTransformer,
  votingOperationsPiballotsFilterListResponseTransformer,
  votingOperationsPimeetingsFilterListResponseTransformer,
  votingPolicyProposalSetRecommendationCoverageDetailRetrieveResponseTransformer,
  votingPolicyProposalSetRecommendationCoverageSearchCreateResponseTransformer,
  votingPolicyProviderVotingRecommendationsCreateResponseTransformer,
  votingPolicyProviderVotingRecommendationsFetchByVersionRetrieveResponseTransformer,
  votingPolicyProviderVotingRecommendationsMatchCreateResponseTransformer,
  votingPolicyProviderVotingRecommendationsSearchCreateResponseTransformer,
  votingPolicyProxyIntermediaryVotingRecommendationConfidenceScoresUpdateResponseTransformer,
  votingPolicyProxyIntermediaryVotingRecommendationsCreateResponseTransformer,
  votingPolicyProxyIntermediaryVotingRecommendationsMatchFromPvrCreateResponseTransformer,
  votingPolicyProxyIntermediaryVotingRecommendationsSearchCreateResponseTransformer,
  votingPolicyProxyIntermediaryVotingRecommendationsVersionsRetrieveResponseTransformer,
  votingPolicyProxyIntermediaryVotingRecommendationValidationStatusesCreateResponseTransformer,
  votingPolicyProxyIntermediaryVotingRecommendationValidationStatusesSearchCreateResponseTransformer,
  votingPolicyVotingPoliciesCreateResponseTransformer,
  votingPolicyVotingPoliciesDocumentsCreateResponseTransformer,
  votingPolicyVotingPoliciesDocumentsListResponseTransformer,
  votingPolicyVotingPoliciesDocumentsPartialUpdateResponseTransformer,
  votingPolicyVotingPoliciesDocumentsRetrieveResponseTransformer,
  votingPolicyVotingPoliciesPartialUpdateResponseTransformer,
  votingPolicyVotingPoliciesRetrieveResponseTransformer,
  votingPolicyVotingPoliciesSearchCreateResponseTransformer,
  votingPolicyVotingPoliciesVotingRecommendationsCreateResponseTransformer,
  votingPolicyVotingPoliciesVotingRecommendationsPartialUpdateResponseTransformer,
  votingPolicyVotingPoliciesVotingRecommendationsRetrieveResponseTransformer,
  votingPolicyVotingPoliciesVotingRecommendationsSearchCreateResponseTransformer,
  votingPolicyVotingPoliciesVotingRecommendationsUpdateFromPvrCreateResponseTransformer,
  votingPolicyVotingRecommendationConfidenceScoresUpdateResponseTransformer,
} from './transformers.gen'
import type {
  ApiSchemaRetrieveData,
  ApiSchemaRetrieveResponses,
  BackgroundTasksTasksRetrieveData,
  BackgroundTasksTasksRetrieveErrors,
  BackgroundTasksTasksRetrieveResponses,
  DirectoutreachBetanxtVoterPolicySnapshotExportCreateData,
  DirectoutreachBetanxtVoterPolicySnapshotExportCreateResponses,
  DirectoutreachPolicyAvailableListData,
  DirectoutreachPolicyAvailableListResponses,
  DirectoutreachPolicyAvailableRetrieveData,
  DirectoutreachPolicyAvailableRetrieveResponses,
  DirectoutreachPolicyCreateData,
  DirectoutreachPolicyCreateResponses,
  DirectoutreachVotersBatchCreateCreateData,
  DirectoutreachVotersBatchCreateCreateErrors,
  DirectoutreachVotersBatchCreateCreateResponses,
  DirectoutreachVotersCreateCreateData,
  DirectoutreachVotersCreateCreateResponses,
  DirectoutreachVotersHoldingsRetrieveData,
  DirectoutreachVotersHoldingsRetrieveErrors,
  DirectoutreachVotersHoldingsRetrieveResponses,
  DirectoutreachVotersRetrieveData,
  DirectoutreachVotersRetrieveErrors,
  DirectoutreachVotersRetrieveResponses,
  DirectoutreachVotersSelectedPolicyCreateData,
  DirectoutreachVotersSelectedPolicyCreateErrors,
  DirectoutreachVotersSelectedPolicyCreateResponses,
  DirectoutreachVotersSelectedPolicyRetrieveData,
  DirectoutreachVotersSelectedPolicyRetrieveErrors,
  DirectoutreachVotersSelectedPolicyRetrieveResponses,
  DirectvotingBallotsCastVoteCreateData,
  DirectvotingBallotsCastVoteCreateErrors,
  DirectvotingBallotsCastVoteCreateResponses,
  DirectvotingBallotsProposalsRetrieveData,
  DirectvotingBallotsProposalsRetrieveErrors,
  DirectvotingBallotsProposalsRetrieveResponses,
  DirectvotingBallotsSearchCreateData,
  DirectvotingBallotsSearchCreateErrors,
  DirectvotingBallotsSearchCreateResponses,
  DirectvotingBallotStampsRetrieveData,
  DirectvotingBallotStampsRetrieveErrors,
  DirectvotingBallotStampsRetrieveResponses,
  DirectvotingBallotStampsSearchCreateData,
  DirectvotingBallotStampsSearchCreateErrors,
  DirectvotingBallotStampsSearchCreateResponses,
  DirectvotingBallotWorkflowItemsCreateData,
  DirectvotingBallotWorkflowItemsCreateErrors,
  DirectvotingBallotWorkflowItemsCreateResponses,
  DirectvotingBallotWorkflowItemsDestroyData,
  DirectvotingBallotWorkflowItemsDestroyErrors,
  DirectvotingBallotWorkflowItemsDestroyResponses,
  DirectvotingBallotWorkflowItemsPartialUpdateData,
  DirectvotingBallotWorkflowItemsPartialUpdateErrors,
  DirectvotingBallotWorkflowItemsPartialUpdateResponses,
  DirectvotingBallotWorkflowItemsRetrieveData,
  DirectvotingBallotWorkflowItemsRetrieveErrors,
  DirectvotingBallotWorkflowItemsRetrieveResponses,
  DirectvotingBallotWorkflowItemsSearchCreateData,
  DirectvotingBallotWorkflowItemsSearchCreateErrors,
  DirectvotingBallotWorkflowItemsSearchCreateResponses,
  DirectvotingBeaconRuleOutputsCreateData,
  DirectvotingBeaconRuleOutputsCreateErrors,
  DirectvotingBeaconRuleOutputsCreateResponses,
  DirectvotingBeaconRuleOutputsDestroyData,
  DirectvotingBeaconRuleOutputsDestroyErrors,
  DirectvotingBeaconRuleOutputsDestroyResponses,
  DirectvotingBeaconRuleOutputsRetrieveData,
  DirectvotingBeaconRuleOutputsRetrieveErrors,
  DirectvotingBeaconRuleOutputsRetrieveResponses,
  DirectvotingBeaconRuleOutputsSearchCreateData,
  DirectvotingBeaconRuleOutputsSearchCreateErrors,
  DirectvotingBeaconRuleOutputsSearchCreateResponses,
  DirectvotingCustodyAccountGroupMembershipsCreateData,
  DirectvotingCustodyAccountGroupMembershipsCreateErrors,
  DirectvotingCustodyAccountGroupMembershipsCreateResponses,
  DirectvotingCustodyAccountGroupMembershipsDestroyData,
  DirectvotingCustodyAccountGroupMembershipsDestroyErrors,
  DirectvotingCustodyAccountGroupMembershipsDestroyResponses,
  DirectvotingCustodyAccountGroupMembershipsSearchCreateData,
  DirectvotingCustodyAccountGroupMembershipsSearchCreateErrors,
  DirectvotingCustodyAccountGroupMembershipsSearchCreateResponses,
  DirectvotingCustodyAccountGroupsCreateData,
  DirectvotingCustodyAccountGroupsCreateErrors,
  DirectvotingCustodyAccountGroupsCreateResponses,
  DirectvotingCustodyAccountGroupsDestroyData,
  DirectvotingCustodyAccountGroupsDestroyErrors,
  DirectvotingCustodyAccountGroupsDestroyResponses,
  DirectvotingCustodyAccountGroupsPartialUpdateData,
  DirectvotingCustodyAccountGroupsPartialUpdateErrors,
  DirectvotingCustodyAccountGroupsPartialUpdateResponses,
  DirectvotingCustodyAccountGroupsRetrieveData,
  DirectvotingCustodyAccountGroupsRetrieveErrors,
  DirectvotingCustodyAccountGroupsRetrieveResponses,
  DirectvotingCustodyAccountGroupsSearchCreateData,
  DirectvotingCustodyAccountGroupsSearchCreateErrors,
  DirectvotingCustodyAccountGroupsSearchCreateResponses,
  DirectvotingCustodyAccountGroupsUpdateData,
  DirectvotingCustodyAccountGroupsUpdateErrors,
  DirectvotingCustodyAccountGroupsUpdateResponses,
  DirectvotingCustodyAccountTenantLinksLinkCreateData,
  DirectvotingCustodyAccountTenantLinksLinkCreateErrors,
  DirectvotingCustodyAccountTenantLinksLinkCreateResponses,
  DirectvotingCustodyAccountTenantLinksListData,
  DirectvotingCustodyAccountTenantLinksListErrors,
  DirectvotingCustodyAccountTenantLinksListResponses,
  DirectvotingCustodyAccountTenantLinksUnlinkCreateData,
  DirectvotingCustodyAccountTenantLinksUnlinkCreateErrors,
  DirectvotingCustodyAccountTenantLinksUnlinkCreateResponses,
  DirectvotingCustodyAccountVotingPolicySelectionsCreateData,
  DirectvotingCustodyAccountVotingPolicySelectionsCreateErrors,
  DirectvotingCustodyAccountVotingPolicySelectionsCreateResponses,
  DirectvotingCustodyAccountVotingPolicySelectionsDestroyData,
  DirectvotingCustodyAccountVotingPolicySelectionsDestroyErrors,
  DirectvotingCustodyAccountVotingPolicySelectionsDestroyResponses,
  DirectvotingCustodyAccountVotingPolicySelectionsPartialUpdateData,
  DirectvotingCustodyAccountVotingPolicySelectionsPartialUpdateErrors,
  DirectvotingCustodyAccountVotingPolicySelectionsPartialUpdateResponses,
  DirectvotingCustodyAccountVotingPolicySelectionsRetrieveData,
  DirectvotingCustodyAccountVotingPolicySelectionsRetrieveErrors,
  DirectvotingCustodyAccountVotingPolicySelectionsRetrieveResponses,
  DirectvotingCustodyAccountVotingPolicySelectionsSearchCreateData,
  DirectvotingCustodyAccountVotingPolicySelectionsSearchCreateErrors,
  DirectvotingCustodyAccountVotingPolicySelectionsSearchCreateResponses,
  DirectvotingCustodyAccountVotingPolicySelectionsUpdateData,
  DirectvotingCustodyAccountVotingPolicySelectionsUpdateErrors,
  DirectvotingCustodyAccountVotingPolicySelectionsUpdateResponses,
  DirectvotingMeetingsAssignmentSearchCreateData,
  DirectvotingMeetingsAssignmentSearchCreateErrors,
  DirectvotingMeetingsAssignmentSearchCreateResponses,
  DirectvotingMeetingsSearchCreateData,
  DirectvotingMeetingsSearchCreateErrors,
  DirectvotingMeetingsSearchCreateResponses,
  DirectvotingRulesEngineRulesCreateData,
  DirectvotingRulesEngineRulesCreateErrors,
  DirectvotingRulesEngineRulesCreateResponses,
  DirectvotingRulesEngineRulesDestroyData,
  DirectvotingRulesEngineRulesDestroyErrors,
  DirectvotingRulesEngineRulesDestroyResponses,
  DirectvotingRulesEngineRulesListsCreateData,
  DirectvotingRulesEngineRulesListsCreateErrors,
  DirectvotingRulesEngineRulesListsCreateResponses,
  DirectvotingRulesEngineRulesListsDestroyData,
  DirectvotingRulesEngineRulesListsDestroyErrors,
  DirectvotingRulesEngineRulesListsDestroyResponses,
  DirectvotingRulesEngineRulesListsPartialUpdateData,
  DirectvotingRulesEngineRulesListsPartialUpdateErrors,
  DirectvotingRulesEngineRulesListsPartialUpdateResponses,
  DirectvotingRulesEngineRulesListsRetrieveData,
  DirectvotingRulesEngineRulesListsRetrieveErrors,
  DirectvotingRulesEngineRulesListsRetrieveResponses,
  DirectvotingRulesEngineRulesListsSearchCreateData,
  DirectvotingRulesEngineRulesListsSearchCreateErrors,
  DirectvotingRulesEngineRulesListsSearchCreateResponses,
  DirectvotingRulesEngineRulesPartialUpdateData,
  DirectvotingRulesEngineRulesPartialUpdateErrors,
  DirectvotingRulesEngineRulesPartialUpdateResponses,
  DirectvotingRulesEngineRulesRetrieveData,
  DirectvotingRulesEngineRulesRetrieveErrors,
  DirectvotingRulesEngineRulesRetrieveResponses,
  DirectvotingRulesEngineRulesSearchCreateData,
  DirectvotingRulesEngineRulesSearchCreateErrors,
  DirectvotingRulesEngineRulesSearchCreateResponses,
  DirectvotingWatchlistItemsBatchCreateData,
  DirectvotingWatchlistItemsBatchCreateErrors,
  DirectvotingWatchlistItemsBatchCreateResponses,
  DirectvotingWatchlistItemsCreateData,
  DirectvotingWatchlistItemsCreateErrors,
  DirectvotingWatchlistItemsCreateResponses,
  DirectvotingWatchlistItemsDestroyData,
  DirectvotingWatchlistItemsDestroyErrors,
  DirectvotingWatchlistItemsDestroyResponses,
  DirectvotingWatchlistItemsRetrieveData,
  DirectvotingWatchlistItemsRetrieveErrors,
  DirectvotingWatchlistItemsRetrieveResponses,
  DirectvotingWatchlistItemsSearchCreateData,
  DirectvotingWatchlistItemsSearchCreateErrors,
  DirectvotingWatchlistItemsSearchCreateResponses,
  DirectvotingWatchlistsCreateData,
  DirectvotingWatchlistsCreateErrors,
  DirectvotingWatchlistsCreateResponses,
  DirectvotingWatchlistsDestroyData,
  DirectvotingWatchlistsDestroyErrors,
  DirectvotingWatchlistsDestroyResponses,
  DirectvotingWatchlistsPartialUpdateData,
  DirectvotingWatchlistsPartialUpdateErrors,
  DirectvotingWatchlistsPartialUpdateResponses,
  DirectvotingWatchlistsRetrieveData,
  DirectvotingWatchlistsRetrieveErrors,
  DirectvotingWatchlistsRetrieveResponses,
  DirectvotingWatchlistsSearchCreateData,
  DirectvotingWatchlistsSearchCreateErrors,
  DirectvotingWatchlistsSearchCreateResponses,
  FundManagerFundManagersCreateData,
  FundManagerFundManagersCreateResponses,
  FundManagerFundManagersPoliciesCreateData,
  FundManagerFundManagersPoliciesCreateResponses,
  FundManagerFundManagersPoliciesRetrieveData,
  FundManagerFundManagersPoliciesRetrieveResponses,
  FundManagerFundManagersRetrieveData,
  FundManagerFundManagersRetrieveResponses,
  FundManagerFundManagersSearchCreateData,
  FundManagerFundManagersSearchCreateResponses,
  FundManagerFundManagersUpdateData,
  FundManagerFundManagersUpdateResponses,
  FundManagerFundsCreateData,
  FundManagerFundsCreateResponses,
  FundManagerFundsQuantificationSnapshotsCreateData,
  FundManagerFundsQuantificationSnapshotsCreateResponses,
  FundManagerFundsRetrieveData,
  FundManagerFundsRetrieveResponses,
  FundManagerFundsSearchCreateData,
  FundManagerFundsSearchCreateResponses,
  FundManagerFundsUpdateData,
  FundManagerFundsUpdateResponses,
  FundManagerFundVariantsCreateData,
  FundManagerFundVariantsCreateResponses,
  FundManagerFundVariantsDestroyData,
  FundManagerFundVariantsDestroyResponses,
  FundManagerFundVariantsRetrieveData,
  FundManagerFundVariantsRetrieveResponses,
  FundManagerFundVariantsSearchCreateData,
  FundManagerFundVariantsSearchCreateResponses,
  FundManagerFundVariantsUpdateData,
  FundManagerFundVariantsUpdateResponses,
  FundManagerProvidersCreateData,
  FundManagerProvidersCreateResponses,
  FundManagerProvidersListData,
  FundManagerProvidersListResponses,
  FundManagerProvidersRetrieveData,
  FundManagerProvidersRetrieveResponses,
  FundManagerProvidersUpdateData,
  FundManagerProvidersUpdateResponses,
  FundManagerPublicSecurityIdsCreateData,
  FundManagerPublicSecurityIdsCreateResponses,
  FundManagerPublicSecurityIdsSearchCreateData,
  FundManagerPublicSecurityIdsSearchCreateResponses,
  FundManagerQuantificationSnapshotsSearchCreateData,
  FundManagerQuantificationSnapshotsSearchCreateResponses,
  InstitutionalMeetingsearchListData,
  InstitutionalMeetingsearchListResponses,
  IssuerFiscalYearsCreateData,
  IssuerFiscalYearsCreateErrors,
  IssuerFiscalYearsCreateResponses,
  IssuerFiscalYearsSearchCreateData,
  IssuerFiscalYearsSearchCreateErrors,
  IssuerFiscalYearsSearchCreateResponses,
  IssuerInstrumentsCreateData,
  IssuerInstrumentsCreateErrors,
  IssuerInstrumentsCreateResponses,
  IssuerInstrumentsOutstandingSharesCreateData,
  IssuerInstrumentsOutstandingSharesCreateErrors,
  IssuerInstrumentsOutstandingSharesCreateResponses,
  IssuerInstrumentsOutstandingSharesRetrieveData,
  IssuerInstrumentsOutstandingSharesRetrieveErrors,
  IssuerInstrumentsOutstandingSharesRetrieveResponses,
  IssuerInstrumentsRetrieveData,
  IssuerInstrumentsRetrieveErrors,
  IssuerInstrumentsRetrieveResponses,
  IssuerInstrumentsSearchCreateData,
  IssuerInstrumentsSearchCreateErrors,
  IssuerInstrumentsSearchCreateResponses,
  IssuerInstrumentsTotalShareholderReturnCreateData,
  IssuerInstrumentsTotalShareholderReturnCreateErrors,
  IssuerInstrumentsTotalShareholderReturnCreateResponses,
  IssuerInstrumentsTotalShareholderReturnRetrieveData,
  IssuerInstrumentsTotalShareholderReturnRetrieveErrors,
  IssuerInstrumentsTotalShareholderReturnRetrieveResponses,
  IssuerIssuersCreateData,
  IssuerIssuersCreateErrors,
  IssuerIssuersCreateResponses,
  IssuerIssuersMarketCapitalisationCreateData,
  IssuerIssuersMarketCapitalisationCreateErrors,
  IssuerIssuersMarketCapitalisationCreateResponses,
  IssuerIssuersMarketCapitalisationRetrieveData,
  IssuerIssuersMarketCapitalisationRetrieveErrors,
  IssuerIssuersMarketCapitalisationRetrieveResponses,
  IssuerIssuersRetrieveData,
  IssuerIssuersRetrieveErrors,
  IssuerIssuersRetrieveResponses,
  IssuerIssuersSearchCreateData,
  IssuerIssuersSearchCreateErrors,
  IssuerIssuersSearchCreateResponses,
  ProxyIntermediaryBallotsFetchByVersionIdsCreateData,
  ProxyIntermediaryBallotsFetchByVersionIdsCreateResponses,
  ProxyIntermediaryBallotsProxymityStaleProposalSetListData,
  ProxyIntermediaryBallotsProxymityStaleProposalSetListResponses,
  ProxyIntermediaryBallotsSearchCreateData,
  ProxyIntermediaryBallotsSearchCreateResponses,
  ProxyIntermediaryBallotsUpsertCreateData,
  ProxyIntermediaryBallotsUpsertCreateResponses,
  ProxyIntermediaryBallotsVersionsListData,
  ProxyIntermediaryBallotsVersionsListResponses,
  ProxyIntermediaryCustodyAccountsCreateData,
  ProxyIntermediaryCustodyAccountsCreateErrors,
  ProxyIntermediaryCustodyAccountsCreateResponses,
  ProxyIntermediaryCustodyAccountsDestroyData,
  ProxyIntermediaryCustodyAccountsDestroyErrors,
  ProxyIntermediaryCustodyAccountsDestroyResponses,
  ProxyIntermediaryCustodyAccountsPartialUpdateData,
  ProxyIntermediaryCustodyAccountsPartialUpdateErrors,
  ProxyIntermediaryCustodyAccountsPartialUpdateResponses,
  ProxyIntermediaryCustodyAccountsRetrieveData,
  ProxyIntermediaryCustodyAccountsRetrieveErrors,
  ProxyIntermediaryCustodyAccountsRetrieveResponses,
  ProxyIntermediaryCustodyAccountsSearchCreateData,
  ProxyIntermediaryCustodyAccountsSearchCreateErrors,
  ProxyIntermediaryCustodyAccountsSearchCreateResponses,
  ProxyIntermediaryCustodyAccountsUpdateData,
  ProxyIntermediaryCustodyAccountsUpdateErrors,
  ProxyIntermediaryCustodyAccountsUpdateResponses,
  ProxyIntermediaryPiProposalCategoriesUpsertCreateData,
  ProxyIntermediaryPiProposalCategoriesUpsertCreateResponses,
  ProxyIntermediaryProposalCategoriesAssignCreateData,
  ProxyIntermediaryProposalCategoriesAssignCreateResponses,
  ProxyIntermediaryProposalCategoriesListCreateData,
  ProxyIntermediaryProposalCategoriesListCreateResponses,
  ProxyIntermediaryProposalLabelsAssignCreateData,
  ProxyIntermediaryProposalLabelsAssignCreateResponses,
  ProxyIntermediaryProposalLabelsFetchCreateData,
  ProxyIntermediaryProposalLabelsFetchCreateResponses,
  ProxyIntermediaryProposalsBroadridgeProposalSetFetchLatestCreateData,
  ProxyIntermediaryProposalsBroadridgeProposalSetFetchLatestCreateResponses,
  ProxyIntermediaryProposalsCreateCreateData,
  ProxyIntermediaryProposalsCreateCreateResponses,
  ProxyIntermediaryProposalsDeleteCreateData,
  ProxyIntermediaryProposalsDeleteCreateResponses,
  ProxyIntermediaryProposalsProxymityProposalSetFetchLatestCreateData,
  ProxyIntermediaryProposalsProxymityProposalSetFetchLatestCreateResponses,
  ProxyIntermediaryProposalsSearchCreateData,
  ProxyIntermediaryProposalsSearchCreateResponses,
  ProxyIntermediaryProxyedgeVotesCreateCreateData,
  ProxyIntermediaryProxyedgeVotesCreateCreateResponses,
  ProxyIntermediaryProxyedgeVotesFetchLatestCreateData,
  ProxyIntermediaryProxyedgeVotesFetchLatestCreateResponses,
  ProxyIntermediaryProxyIntermediariesSearchCreateData,
  ProxyIntermediaryProxyIntermediariesSearchCreateResponses,
  ProxyIntermediaryProxyIntermediaryMeetingsAuditEventsSearchCreateData,
  ProxyIntermediaryProxyIntermediaryMeetingsAuditEventsSearchCreateResponses,
  ProxyIntermediaryProxyIntermediaryMeetingsCancelCreateData,
  ProxyIntermediaryProxyIntermediaryMeetingsCancelCreateResponses,
  ProxyIntermediaryProxyIntermediaryMeetingsHardDeleteCreateData,
  ProxyIntermediaryProxyIntermediaryMeetingsHardDeleteCreateResponses,
  ProxyIntermediaryProxyIntermediaryMeetingsLinkTransparencyGeneralMeetingCreateData,
  ProxyIntermediaryProxyIntermediaryMeetingsLinkTransparencyGeneralMeetingCreateResponses,
  ProxyIntermediaryProxyIntermediaryMeetingsSearchCreateData,
  ProxyIntermediaryProxyIntermediaryMeetingsSearchCreateResponses,
  ProxyIntermediaryProxyIntermediaryMeetingsUnlinkTransparencyGeneralMeetingCreateData,
  ProxyIntermediaryProxyIntermediaryMeetingsUnlinkTransparencyGeneralMeetingCreateResponses,
  ProxyIntermediaryProxyIntermediaryMeetingsUpsertCreateData,
  ProxyIntermediaryProxyIntermediaryMeetingsUpsertCreateResponses,
  ProxyIntermediaryProxymityVotesCreateCreateData,
  ProxyIntermediaryProxymityVotesCreateCreateResponses,
  ProxyIntermediaryProxymityVotesFetchLatestCreateData,
  ProxyIntermediaryProxymityVotesFetchLatestCreateResponses,
  ProxyIntermediaryVoteStatusesDeleteCreateData,
  ProxyIntermediaryVoteStatusesDeleteCreateResponses,
  ProxyIntermediaryVoteStatusesUpsertCreateData,
  ProxyIntermediaryVoteStatusesUpsertCreateResponses,
  ProxyvotingEntitlementsBreakdownCreateData,
  ProxyvotingEntitlementsBreakdownCreateResponses,
  ProxyvotingEntitlementsComputeCreateData,
  ProxyvotingEntitlementsComputeCreateResponses,
  ProxyvotingEntitlementsListData,
  ProxyvotingEntitlementsListResponses,
  ProxyvotingFundManagerCompositionsSiiFromCompositionDifferenceCreateData,
  ProxyvotingFundManagerCompositionsSiiFromCompositionDifferenceCreateResponses,
  ProxyvotingFundManagerPolicySupportedIssuedInstrumentsBatchDeleteCreateData,
  ProxyvotingFundManagerPolicySupportedIssuedInstrumentsBatchDeleteCreateResponses,
  ProxyvotingFundManagerPolicySupportedIssuedInstrumentsCreateData,
  ProxyvotingFundManagerPolicySupportedIssuedInstrumentsCreateResponses,
  ProxyvotingFundManagerPolicySupportedIssuedInstrumentsSearchCreateData,
  ProxyvotingFundManagerPolicySupportedIssuedInstrumentsSearchCreateResponses,
  ProxyvotingFundManagerSupportedPoliciesCreateData,
  ProxyvotingFundManagerSupportedPoliciesCreateResponses,
  ProxyvotingFundManagerSupportedPoliciesDestroyData,
  ProxyvotingFundManagerSupportedPoliciesDestroyResponses,
  ProxyvotingFundManagerSupportedPoliciesListData,
  ProxyvotingFundManagerSupportedPoliciesListResponses,
  ProxyvotingInvestorCompositionsDifferenceListData,
  ProxyvotingInvestorCompositionsDifferenceListResponses,
  ProxyvotingInvestorCompositionsRenderCreateData,
  ProxyvotingInvestorCompositionsRenderCreateResponses,
  ProxyvotingInvestorCompositionsRulesEngineRetrieveData,
  ProxyvotingInvestorCompositionsRulesEngineRetrieveResponses,
  ProxyvotingInvestorCompositionsRulesEngineUpdateData,
  ProxyvotingInvestorCompositionsRulesEngineUpdateResponses,
  ProxyvotingInvestorCompositionsSiiFromCompositionDifferenceCreateData,
  ProxyvotingInvestorCompositionsSiiFromCompositionDifferenceCreateResponses,
  ProxyvotingInvestorPolicySupportedIssuedInstrumentsBatchDeleteCreateData,
  ProxyvotingInvestorPolicySupportedIssuedInstrumentsBatchDeleteCreateResponses,
  ProxyvotingInvestorPolicySupportedIssuedInstrumentsCreateData,
  ProxyvotingInvestorPolicySupportedIssuedInstrumentsCreateResponses,
  ProxyvotingInvestorPolicySupportedIssuedInstrumentsSearchCreateData,
  ProxyvotingInvestorPolicySupportedIssuedInstrumentsSearchCreateResponses,
  ProxyvotingInvestorSupportedIssuedInstrumentsBatchDeleteCreateData,
  ProxyvotingInvestorSupportedIssuedInstrumentsBatchDeleteCreateResponses,
  ProxyvotingInvestorSupportedIssuedInstrumentsCreateData,
  ProxyvotingInvestorSupportedIssuedInstrumentsCreateResponses,
  ProxyvotingInvestorSupportedIssuedInstrumentsSearchCreateData,
  ProxyvotingInvestorSupportedIssuedInstrumentsSearchCreateResponses,
  ProxyvotingMeetingballotsComputeCreateData,
  ProxyvotingMeetingballotsComputeCreateResponses,
  ProxyvotingMeetingBallotsListData,
  ProxyvotingMeetingBallotsListResponses,
  ProxyvotingMeetingBallotSourcesListData,
  ProxyvotingMeetingBallotSourcesListResponses,
  ProxyvotingPiballotsFilterListData,
  ProxyvotingPiballotsFilterListResponses,
  ProxyvotingPiballotsInvestorsCanVoteCreateData,
  ProxyvotingPiballotsInvestorsCanVoteCreateResponses,
  ProxyvotingPimeetingsFilterListData,
  ProxyvotingPimeetingsFilterListResponses,
  ProxyvotingRulesEngineDefinitionsByNameDestroyData,
  ProxyvotingRulesEngineDefinitionsByNameDestroyErrors,
  ProxyvotingRulesEngineDefinitionsByNameDestroyResponses,
  ProxyvotingRulesEngineDefinitionsCreateData,
  ProxyvotingRulesEngineDefinitionsCreateResponses,
  ProxyvotingRulesEngineDefinitionsDestroyData,
  ProxyvotingRulesEngineDefinitionsDestroyErrors,
  ProxyvotingRulesEngineDefinitionsDestroyResponses,
  ProxyvotingRulesEngineDefinitionsListData,
  ProxyvotingRulesEngineDefinitionsListResponses,
  ProxyvotingRulesEngineDefinitionsNamesRetrieveData,
  ProxyvotingRulesEngineDefinitionsNamesRetrieveResponses,
  ProxyvotingRulesEngineDefinitionsRetrieveData,
  ProxyvotingRulesEngineDefinitionsRetrieveResponses,
  ProxyvotingRulesEngineDefinitionsRulesCreateData,
  ProxyvotingRulesEngineDefinitionsRulesCreateResponses,
  ProxyvotingRulesEngineDefinitionsRulesDestroyData,
  ProxyvotingRulesEngineDefinitionsRulesDestroyResponses,
  ProxyvotingRulesEngineDefinitionsRulesListData,
  ProxyvotingRulesEngineDefinitionsRulesListResponses,
  ProxyvotingRulesEngineDefinitionsRulesUpdateData,
  ProxyvotingRulesEngineDefinitionsRulesUpdateResponses,
  ProxyvotingSviProposalOverwriteCreateData,
  ProxyvotingSviProposalOverwriteCreateResponses,
  ProxyvotingSviProposalOverwriteReasonsListData,
  ProxyvotingSviProposalOverwriteReasonsListResponses,
  ProxyvotingSviSubmitVoteCreateData,
  ProxyvotingSviSubmitVoteCreateResponses,
  TenancyPermissionGroupsCreateData,
  TenancyPermissionGroupsCreateErrors,
  TenancyPermissionGroupsCreateResponses,
  TenancyPermissionGroupsDestroyData,
  TenancyPermissionGroupsDestroyErrors,
  TenancyPermissionGroupsDestroyResponses,
  TenancyPermissionGroupsUpdateData,
  TenancyPermissionGroupsUpdateErrors,
  TenancyPermissionGroupsUpdateResponses,
  TenancyRolesCreateData,
  TenancyRolesCreateErrors,
  TenancyRolesCreateResponses,
  TenancyRolesDestroyData,
  TenancyRolesDestroyErrors,
  TenancyRolesDestroyResponses,
  TenancyRolesPartialUpdateData,
  TenancyRolesPartialUpdateErrors,
  TenancyRolesPartialUpdateResponses,
  TenancyRolesRetrieveData,
  TenancyRolesRetrieveErrors,
  TenancyRolesRetrieveResponses,
  TenancyRolesSearchCreateData,
  TenancyRolesSearchCreateErrors,
  TenancyRolesSearchCreateResponses,
  TenancyRolesUpdateData,
  TenancyRolesUpdateErrors,
  TenancyRolesUpdateResponses,
  TenancyTenantsCreateData,
  TenancyTenantsCreateResponses,
  TenancyTenantsDestroyData,
  TenancyTenantsDestroyResponses,
  TenancyTenantsRetrieveData,
  TenancyTenantsRetrieveResponses,
  TenancyTenantsSearchCreateData,
  TenancyTenantsSearchCreateResponses,
  TenancyTenantsUpdateData,
  TenancyTenantsUpdateResponses,
  TenancyUsersCreateData,
  TenancyUsersCreateResponses,
  TenancyUsersDestroyData,
  TenancyUsersDestroyResponses,
  TenancyUsersRetrieveData,
  TenancyUsersRetrieveResponses,
  TenancyUsersSearchCreateData,
  TenancyUsersSearchCreateResponses,
  TenancyUsersUpdateData,
  TenancyUsersUpdateResponses,
  TransparencyAuditEventsSearchCreateData,
  TransparencyAuditEventsSearchCreateResponses,
  TransparencyExternalMeetingIdsCreateData,
  TransparencyExternalMeetingIdsCreateResponses,
  TransparencyExternalMeetingIdsDestroyData,
  TransparencyExternalMeetingIdsDestroyResponses,
  TransparencyGeneralMeetingsCreateData,
  TransparencyGeneralMeetingsCreateResponses,
  TransparencyGeneralMeetingsPartialUpdateData,
  TransparencyGeneralMeetingsPartialUpdateResponses,
  TransparencyGeneralMeetingsRetrieveData,
  TransparencyGeneralMeetingsRetrieveResponses,
  TransparencyGeneralMeetingsSearchCreateData,
  TransparencyGeneralMeetingsSearchCreateResponses,
  TransparencyInstrumentsCreateData,
  TransparencyInstrumentsCreateResponses,
  TransparencyInstrumentsDestroyData,
  TransparencyInstrumentsDestroyResponses,
  TransparencyInstrumentsFetchMinimalCreateData,
  TransparencyInstrumentsFetchMinimalCreateResponses,
  TransparencyInstrumentsRetrieveData,
  TransparencyInstrumentsRetrieveResponses,
  TransparencyInstrumentsSearchCreateData,
  TransparencyInstrumentsSearchCreateResponses,
  TransparencyInstrumentsUnassociatedRetrieveData,
  TransparencyInstrumentsUnassociatedRetrieveResponses,
  TransparencyInstrumentsUpdateData,
  TransparencyInstrumentsUpdateResponses,
  TransparencyOrganizationsCreateData,
  TransparencyOrganizationsCreateResponses,
  TransparencyOrganizationsDestroyData,
  TransparencyOrganizationsDestroyResponses,
  TransparencyOrganizationsGeneralMeetingsProposalsCreateData,
  TransparencyOrganizationsGeneralMeetingsProposalsCreateResponses,
  TransparencyOrganizationsGeneralMeetingsProposalsPartialUpdateData,
  TransparencyOrganizationsGeneralMeetingsProposalsPartialUpdateResponses,
  TransparencyOrganizationsGeneralMeetingsProposalsRetrieveData,
  TransparencyOrganizationsGeneralMeetingsProposalsRetrieveResponses,
  TransparencyOrganizationsGeneralMeetingsProposalsSearchCreateData,
  TransparencyOrganizationsGeneralMeetingsProposalsSearchCreateResponses,
  TransparencyOrganizationsGeneralMeetingsProposalsUpdateData,
  TransparencyOrganizationsGeneralMeetingsProposalsUpdateResponses,
  TransparencyOrganizationsGetByIdentifierCreateData,
  TransparencyOrganizationsGetByIdentifierCreateResponses,
  TransparencyOrganizationsIsinsToNamesCreateData,
  TransparencyOrganizationsIsinsToNamesCreateResponses,
  TransparencyOrganizationsLogoCreateData,
  TransparencyOrganizationsLogoCreateResponses,
  TransparencyOrganizationsPartialUpdateData,
  TransparencyOrganizationsPartialUpdateResponses,
  TransparencyOrganizationsRetrieveData,
  TransparencyOrganizationsRetrieveResponses,
  TransparencyOrganizationsSearchCreateData,
  TransparencyOrganizationsSearchCreateResponses,
  TransparencyOrganizationsUpdateData,
  TransparencyOrganizationsUpdateResponses,
  TransparencyProposalsClassificationCodesRetrieveData,
  TransparencyProposalsClassificationCodesRetrieveResponses,
  TransparencyProposalsCountCreateData,
  TransparencyProposalsCountCreateResponses,
  TransparencyProposalsFetchCreateData,
  TransparencyProposalsFetchCreateResponses,
  TransparencyProposalsFetchNamesFromIdsCreateData,
  TransparencyProposalsFetchNamesFromIdsCreateResponses,
  TransparencyProposalsSecClassificationCodesRetrieveData,
  TransparencyProposalsSecClassificationCodesRetrieveResponses,
  TransparencyPublicSecurityIdsSearchCreateData,
  TransparencyPublicSecurityIdsSearchCreateResponses,
  VotingOperationsPiballotsFilterListData,
  VotingOperationsPiballotsFilterListResponses,
  VotingOperationsPimeetingsFilterListData,
  VotingOperationsPimeetingsFilterListResponses,
  VotingPolicyProposalSetRecommendationCoverageDetailRetrieveData,
  VotingPolicyProposalSetRecommendationCoverageDetailRetrieveResponses,
  VotingPolicyProposalSetRecommendationCoverageSearchCreateData,
  VotingPolicyProposalSetRecommendationCoverageSearchCreateErrors,
  VotingPolicyProposalSetRecommendationCoverageSearchCreateResponses,
  VotingPolicyProviderVotingRecommendationsCreateData,
  VotingPolicyProviderVotingRecommendationsCreateResponses,
  VotingPolicyProviderVotingRecommendationsDestroyData,
  VotingPolicyProviderVotingRecommendationsDestroyResponses,
  VotingPolicyProviderVotingRecommendationsFetchByVersionRetrieveData,
  VotingPolicyProviderVotingRecommendationsFetchByVersionRetrieveResponses,
  VotingPolicyProviderVotingRecommendationsMatchCreateData,
  VotingPolicyProviderVotingRecommendationsMatchCreateResponses,
  VotingPolicyProviderVotingRecommendationsSearchCreateData,
  VotingPolicyProviderVotingRecommendationsSearchCreateResponses,
  VotingPolicyProxyIntermediaryVotingRecommendationConfidenceScoresUpdateData,
  VotingPolicyProxyIntermediaryVotingRecommendationConfidenceScoresUpdateResponses,
  VotingPolicyProxyIntermediaryVotingRecommendationsCreateData,
  VotingPolicyProxyIntermediaryVotingRecommendationsCreateResponses,
  VotingPolicyProxyIntermediaryVotingRecommendationsDestroyData,
  VotingPolicyProxyIntermediaryVotingRecommendationsDestroyResponses,
  VotingPolicyProxyIntermediaryVotingRecommendationsMatchFromPvrCreateData,
  VotingPolicyProxyIntermediaryVotingRecommendationsMatchFromPvrCreateResponses,
  VotingPolicyProxyIntermediaryVotingRecommendationsSearchCreateData,
  VotingPolicyProxyIntermediaryVotingRecommendationsSearchCreateResponses,
  VotingPolicyProxyIntermediaryVotingRecommendationsVersionsRetrieveData,
  VotingPolicyProxyIntermediaryVotingRecommendationsVersionsRetrieveResponses,
  VotingPolicyProxyIntermediaryVotingRecommendationValidationStatusesCreateData,
  VotingPolicyProxyIntermediaryVotingRecommendationValidationStatusesCreateResponses,
  VotingPolicyProxyIntermediaryVotingRecommendationValidationStatusesSearchCreateData,
  VotingPolicyProxyIntermediaryVotingRecommendationValidationStatusesSearchCreateResponses,
  VotingPolicyVotingPoliciesCreateData,
  VotingPolicyVotingPoliciesCreateResponses,
  VotingPolicyVotingPoliciesDestroyData,
  VotingPolicyVotingPoliciesDestroyResponses,
  VotingPolicyVotingPoliciesDocumentsCreateData,
  VotingPolicyVotingPoliciesDocumentsCreateResponses,
  VotingPolicyVotingPoliciesDocumentsListData,
  VotingPolicyVotingPoliciesDocumentsListResponses,
  VotingPolicyVotingPoliciesDocumentsPartialUpdateData,
  VotingPolicyVotingPoliciesDocumentsPartialUpdateResponses,
  VotingPolicyVotingPoliciesDocumentsRetrieveData,
  VotingPolicyVotingPoliciesDocumentsRetrieveResponses,
  VotingPolicyVotingPoliciesPartialUpdateData,
  VotingPolicyVotingPoliciesPartialUpdateResponses,
  VotingPolicyVotingPoliciesRetrieveData,
  VotingPolicyVotingPoliciesRetrieveResponses,
  VotingPolicyVotingPoliciesSearchCreateData,
  VotingPolicyVotingPoliciesSearchCreateResponses,
  VotingPolicyVotingPoliciesVotingRecommendationsCreateData,
  VotingPolicyVotingPoliciesVotingRecommendationsCreateResponses,
  VotingPolicyVotingPoliciesVotingRecommendationsDestroyData,
  VotingPolicyVotingPoliciesVotingRecommendationsDestroyResponses,
  VotingPolicyVotingPoliciesVotingRecommendationsPartialUpdateData,
  VotingPolicyVotingPoliciesVotingRecommendationsPartialUpdateResponses,
  VotingPolicyVotingPoliciesVotingRecommendationsRetrieveData,
  VotingPolicyVotingPoliciesVotingRecommendationsRetrieveResponses,
  VotingPolicyVotingPoliciesVotingRecommendationsSearchCreateData,
  VotingPolicyVotingPoliciesVotingRecommendationsSearchCreateResponses,
  VotingPolicyVotingPoliciesVotingRecommendationsUpdateFromPvrCreateData,
  VotingPolicyVotingPoliciesVotingRecommendationsUpdateFromPvrCreateResponses,
  VotingPolicyVotingRecommendationConfidenceScoresUpdateData,
  VotingPolicyVotingRecommendationConfidenceScoresUpdateResponses,
} from './types.gen'

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
  TResponse = unknown,
> = Options2<TData, ThrowOnError, TResponse> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>
}

/**
 * OpenApi3 schema for this API. Format can be selected via content negotiation.
 *
 * - YAML: application/vnd.oai.openapi
 * - JSON: application/vnd.oai.openapi+json
 */
export const apiSchemaRetrieve = <ThrowOnError extends boolean = false>(
  options?: Options<ApiSchemaRetrieveData, ThrowOnError>
) =>
  (options?.client ?? client).get<ApiSchemaRetrieveResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/schema/',
    ...options,
  })

/**
 * Get task status
 *
 * Retrieve the current status and result of a background task by its ID.
 */
export const backgroundTasksTasksRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<BackgroundTasksTasksRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<
    BackgroundTasksTasksRetrieveResponses,
    BackgroundTasksTasksRetrieveErrors,
    ThrowOnError
  >({
    responseTransformer: backgroundTasksTasksRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/background-tasks/tasks/{task_id}/',
    ...options,
  })

/**
 * Export BetaNXT voter policies snapshot to S3
 *
 * Exports voter policies data to S3 as CSV. Includes holdings for the specified valid_time with policy selections. When multiple holdings exist for the same date, selects the most recent. Synchronous operation with 60s timeout. Requires timezone-aware datetime.
 */
export const directoutreachBetanxtVoterPolicySnapshotExportCreate = <ThrowOnError extends boolean = false>(
  options: Options<DirectoutreachBetanxtVoterPolicySnapshotExportCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<DirectoutreachBetanxtVoterPolicySnapshotExportCreateResponses, unknown, ThrowOnError>(
    {
      responseTransformer: directoutreachBetanxtVoterPolicySnapshotExportCreateResponseTransformer,
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/directoutreach/betanxt/voter-policy-snapshot:export/',
      ...options,
    }
  )

/**
 * Create a new voting policy
 *
 * Creates a new voting policy with the provided information.
 */
export const directoutreachPolicyCreate = <ThrowOnError extends boolean = false>(
  options: Options<DirectoutreachPolicyCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<DirectoutreachPolicyCreateResponses, unknown, ThrowOnError>({
    responseTransformer: directoutreachPolicyCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directoutreach/policy/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * List all available voting policies
 *
 * Retrieves a list of all voting available policies.
 */
export const directoutreachPolicyAvailableList = <ThrowOnError extends boolean = false>(
  options?: Options<DirectoutreachPolicyAvailableListData, ThrowOnError>
) =>
  (options?.client ?? client).get<DirectoutreachPolicyAvailableListResponses, unknown, ThrowOnError>({
    responseTransformer: directoutreachPolicyAvailableListResponseTransformer,
    security: [{ name: 'X-Direct-Outreach-Token', type: 'apiKey' }],
    url: '/directoutreach/policy/available/',
    ...options,
  })

/**
 * ViewSet for retrieving available voting policies.
 */
export const directoutreachPolicyAvailableRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<DirectoutreachPolicyAvailableRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<DirectoutreachPolicyAvailableRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: directoutreachPolicyAvailableRetrieveResponseTransformer,
    security: [{ name: 'X-Direct-Outreach-Token', type: 'apiKey' }],
    url: '/directoutreach/policy/available/{id}/',
    ...options,
  })

/**
 * Get voter's details
 *
 * Retrieves the details for the specified voter, including their ID and broker ID. Use 'mine' as the voter ID to get your own details.
 */
export const directoutreachVotersRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<DirectoutreachVotersRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<
    DirectoutreachVotersRetrieveResponses,
    DirectoutreachVotersRetrieveErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Direct-Outreach-Token', type: 'apiKey' }],
    url: '/directoutreach/voters/{id}/',
    ...options,
  })

/**
 * List latest voter's holdings
 *
 * Retrieves the holdings for the specified voter. Use 'mine' as the voter ID to get your own holdings.
 */
export const directoutreachVotersHoldingsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<DirectoutreachVotersHoldingsRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<
    DirectoutreachVotersHoldingsRetrieveResponses,
    DirectoutreachVotersHoldingsRetrieveErrors,
    ThrowOnError
  >({
    responseTransformer: directoutreachVotersHoldingsRetrieveResponseTransformer,
    security: [{ name: 'X-Direct-Outreach-Token', type: 'apiKey' }],
    url: '/directoutreach/voters/{id}/holdings/',
    ...options,
  })

/**
 * Get voter's selected policy
 *
 * Retrieves the voting policy selected by the specified voter. Use 'mine' as the voter ID to get your own selected policy.
 */
export const directoutreachVotersSelectedPolicyRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<DirectoutreachVotersSelectedPolicyRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<
    DirectoutreachVotersSelectedPolicyRetrieveResponses,
    DirectoutreachVotersSelectedPolicyRetrieveErrors,
    ThrowOnError
  >({
    responseTransformer: directoutreachVotersSelectedPolicyRetrieveResponseTransformer,
    security: [{ name: 'X-Direct-Outreach-Token', type: 'apiKey' }],
    url: '/directoutreach/voters/{id}/selected-policy/',
    ...options,
  })

/**
 * Create a new selected policy version
 *
 * Creates a new selected policy record for the specified voter. Use 'mine' as the voter ID to create your own selected policy.
 */
export const directoutreachVotersSelectedPolicyCreate = <ThrowOnError extends boolean = false>(
  options: Options<DirectoutreachVotersSelectedPolicyCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    DirectoutreachVotersSelectedPolicyCreateResponses,
    DirectoutreachVotersSelectedPolicyCreateErrors,
    ThrowOnError
  >({
    responseTransformer: directoutreachVotersSelectedPolicyCreateResponseTransformer,
    security: [{ name: 'X-Direct-Outreach-Token', type: 'apiKey' }],
    url: '/directoutreach/voters/{id}/selected-policy/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Batch create voters with holdings (atomic)
 *
 * Atomically creates or updates multiple voters and their holdings.
 *
 * Each voter is identified by (mediant_id, broker_id). Holdings are created as new records, preserving complete historical data.
 */
export const directoutreachVotersBatchCreateCreate = <ThrowOnError extends boolean = false>(
  options: Options<DirectoutreachVotersBatchCreateCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    DirectoutreachVotersBatchCreateCreateResponses,
    DirectoutreachVotersBatchCreateCreateErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directoutreach/voters:batch-create/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Upsert voter with holdings
 *
 * Creates or updates a voter and creates new version of their holdings. Voters are identified by (mediant_id, broker_id). Each request creates new holding records, preserving complete historical data. Queries return only the latest version of each holding.
 *
 *
 */
export const directoutreachVotersCreateCreate = <ThrowOnError extends boolean = false>(
  options: Options<DirectoutreachVotersCreateCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<DirectoutreachVotersCreateCreateResponses, unknown, ThrowOnError>({
    responseTransformer: directoutreachVotersCreateCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directoutreach/voters:create/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Get a ballot stamp
 *
 * Read endpoints for the stamps the acting tenant's rules recorded against ballots.
 */
export const directvotingBallotStampsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<DirectvotingBallotStampsRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<
    DirectvotingBallotStampsRetrieveResponses,
    DirectvotingBallotStampsRetrieveErrors,
    ThrowOnError
  >({
    responseTransformer: directvotingBallotStampsRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directvoting/ballot-stamps/{identity_id}/',
    ...options,
  })

/**
 * Search ballot stamps
 *
 * Lists the current version of every one of the acting tenant's ballot stamps that is not deleted, ordered by creation time. The tenant is taken from the `X-Acting-Tenant` header, so another tenant's stamps are never returned. Filters (pi_ballot_id, rule_id, custody_account_group_id, stamp_type) travel in the request body and combine with AND; an empty body returns every stamp the tenant has. Pagination uses the `cursor` and `page_size` query parameters.
 */
export const directvotingBallotStampsSearchCreate = <ThrowOnError extends boolean = false>(
  options: Options<DirectvotingBallotStampsSearchCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    DirectvotingBallotStampsSearchCreateResponses,
    DirectvotingBallotStampsSearchCreateErrors,
    ThrowOnError
  >({
    responseTransformer: directvotingBallotStampsSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directvoting/ballot-stamps/search/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Create a ballot workflow item
 *
 * Creates the acting tenant's workflow item for a proxy intermediary ballot, optionally scoped to one of its custody account groups. A tenant has at most one live item per ballot and group, with a null group being the ballot-level item. When `assigned_to_id` names a user, the user named by the `X-Acting-User` header is recorded as `assigned_by_id`, so the header is then required.
 */
export const directvotingBallotWorkflowItemsCreate = <ThrowOnError extends boolean = false>(
  options: Options<DirectvotingBallotWorkflowItemsCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    DirectvotingBallotWorkflowItemsCreateResponses,
    DirectvotingBallotWorkflowItemsCreateErrors,
    ThrowOnError
  >({
    responseTransformer: directvotingBallotWorkflowItemsCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directvoting/ballot-workflow-items/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Delete a ballot workflow item
 *
 * Closes the current version, leaving the identity and all version history in place. The item then no longer appears in search or retrieve, and the ballot and group are free to be given a new item.
 */
export const directvotingBallotWorkflowItemsDestroy = <ThrowOnError extends boolean = false>(
  options: Options<DirectvotingBallotWorkflowItemsDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DirectvotingBallotWorkflowItemsDestroyResponses,
    DirectvotingBallotWorkflowItemsDestroyErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directvoting/ballot-workflow-items/{identity_id}/',
    ...options,
  })

/**
 * Get a ballot workflow item
 *
 * Returns the current version of one of the acting tenant's live workflow items, by identity id.
 */
export const directvotingBallotWorkflowItemsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<DirectvotingBallotWorkflowItemsRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<
    DirectvotingBallotWorkflowItemsRetrieveResponses,
    DirectvotingBallotWorkflowItemsRetrieveErrors,
    ThrowOnError
  >({
    responseTransformer: directvotingBallotWorkflowItemsRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directvoting/ballot-workflow-items/{identity_id}/',
    ...options,
  })

/**
 * Partially update a ballot workflow item
 *
 * Appends a new version carrying the supplied fields; the fields left out carry forward, and a body that changes nothing appends no version. Changing `assigned_to_id` to a user records the user named by the `X-Acting-User` header as `assigned_by_id`; sending `assigned_to_id: null` unassigns the ballot and clears both. The ballot and custody account group are fixed for the life of the item, so a body naming either is rejected.
 */
export const directvotingBallotWorkflowItemsPartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<DirectvotingBallotWorkflowItemsPartialUpdateData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    DirectvotingBallotWorkflowItemsPartialUpdateResponses,
    DirectvotingBallotWorkflowItemsPartialUpdateErrors,
    ThrowOnError
  >({
    responseTransformer: directvotingBallotWorkflowItemsPartialUpdateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directvoting/ballot-workflow-items/{identity_id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Search ballot workflow items
 *
 * Lists the current version of every one of the acting tenant's ballot workflow items that is not deleted, ordered by creation time. The tenant is taken from the `X-Acting-Tenant` header, so another tenant's items are never returned. Filters (pi_ballot_id, custody_account_group_id, review_required, assigned_to_id, assigned_by_id, assigned) travel in the request body and combine with AND; an empty body returns every item the tenant has. Pagination uses the `cursor` and `page_size` query parameters.
 */
export const directvotingBallotWorkflowItemsSearchCreate = <ThrowOnError extends boolean = false>(
  options: Options<DirectvotingBallotWorkflowItemsSearchCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    DirectvotingBallotWorkflowItemsSearchCreateResponses,
    DirectvotingBallotWorkflowItemsSearchCreateErrors,
    ThrowOnError
  >({
    responseTransformer: directvotingBallotWorkflowItemsSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directvoting/ballot-workflow-items/search/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Cast the acting tenant's votes on a ballot
 *
 * Record how the acting tenant instructs every proposal on one of their ballots. The tenant is taken from the `X-Acting-Tenant` header, and the ballot is resolved via that tenant's qualifying ballots, so a ballot the tenant cannot vote on returns 404. The submitted proposals must cover the ballot's proposal set exactly - a missing, unknown or repeated proposal is rejected - and each response must be one of that proposal's own voting options. Votes are refused once the ballot's vote deadline has passed, or when its meeting is cancelled or past its submission deadline. A re-cast that changes anything appends a new version for every proposal in the ballot's proposal set under a new instruction set id, and a re-cast that changes nothing writes nothing. Two casts racing on the same ballot are resolved by returning 409 Conflict to the loser. Instructions are returned in the ballot's proposal order.
 */
export const directvotingBallotsCastVoteCreate = <ThrowOnError extends boolean = false>(
  options: Options<DirectvotingBallotsCastVoteCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    DirectvotingBallotsCastVoteCreateResponses,
    DirectvotingBallotsCastVoteCreateErrors,
    ThrowOnError
  >({
    responseTransformer: directvotingBallotsCastVoteCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directvoting/ballots/{ballot_id}/cast-vote/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * List a ballot's proposals
 *
 * List the proxy intermediary proposals on one of the acting tenant's ballots, resolved through the ballot's linked proposal set. The tenant is taken from the `X-Acting-Tenant` header, and the ballot is resolved via that tenant's qualifying ballots, so a ballot the tenant cannot vote on returns 404. Proposals are ordered by sequence number ascending (nulls last), then id. Each proposal carries the tenant's current instruction on it for this ballot, or null when it has not been instructed, and its category, subcategory and topics, each null when the proposal has not been categorised. Returns an empty list when the ballot has no linked proposal set.
 */
export const directvotingBallotsProposalsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<DirectvotingBallotsProposalsRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<
    DirectvotingBallotsProposalsRetrieveResponses,
    DirectvotingBallotsProposalsRetrieveErrors,
    ThrowOnError
  >({
    responseTransformer: directvotingBallotsProposalsRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directvoting/ballots/{ballot_id}/proposals/',
    ...options,
  })

/**
 * Search the acting tenant's ballots
 *
 * List the proxy intermediary ballots the acting tenant can vote on, resolved through the tenant's linked custody accounts. The tenant is taken from the `X-Acting-Tenant` header. Only current, non-cancelled ballots are returned. Filters travel in the request body; pagination uses the `cursor` and `page_size` query parameters. An optional proxy_intermediary_meeting_id restricts the result to a single meeting.
 */
export const directvotingBallotsSearchCreate = <ThrowOnError extends boolean = false>(
  options: Options<DirectvotingBallotsSearchCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    DirectvotingBallotsSearchCreateResponses,
    DirectvotingBallotsSearchCreateErrors,
    ThrowOnError
  >({
    responseTransformer: directvotingBallotsSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directvoting/ballots/search/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Record a Beacon rule output
 *
 * Records what one Beacon evaluation concluded about one of the acting tenant's ballots, all or nothing. The tenant is taken from the `X-Acting-Tenant` header, and the ballot is resolved via that tenant's qualifying ballots, so a ballot the tenant cannot vote on, or a cancelled one, returns 404. The output is keyed by (pi_ballot_id, proposal_set_id), and proposal_set_id may be the proposal set of any version of the ballot, current or past. Each proposal result is keyed by its proposal id under the output; every pi_proposal_id must name a proposal in the set, but the set need not be covered, and a current result whose proposal is left out is closed. The output's refer_status is derived: refer when any proposal refers, not_refer otherwise. A redelivery that changes nothing writes nothing and returns the current state. Two writes racing on the same ballot are resolved by returning 409 Conflict to the loser. The output is returned with its current proposal results ordered by proposal sequence number.
 */
export const directvotingBeaconRuleOutputsCreate = <ThrowOnError extends boolean = false>(
  options: Options<DirectvotingBeaconRuleOutputsCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    DirectvotingBeaconRuleOutputsCreateResponses,
    DirectvotingBeaconRuleOutputsCreateErrors,
    ThrowOnError
  >({
    responseTransformer: directvotingBeaconRuleOutputsCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directvoting/beacon-rule-outputs/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Delete a Beacon rule output
 *
 * Closes the current version of one of the acting tenant's Beacon rule outputs, by identity id, and every current proposal result under it, leaving the identities and all version history in place. The output then no longer appears in search or retrieve, and a later record for the same ballot and proposal set creates a new output. An unknown, another tenant's or an already deleted output is not found.
 */
export const directvotingBeaconRuleOutputsDestroy = <ThrowOnError extends boolean = false>(
  options: Options<DirectvotingBeaconRuleOutputsDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DirectvotingBeaconRuleOutputsDestroyResponses,
    DirectvotingBeaconRuleOutputsDestroyErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directvoting/beacon-rule-outputs/{identity_id}/',
    ...options,
  })

/**
 * Get a Beacon rule output
 *
 * Returns the current version of one of the acting tenant's Beacon rule outputs, by identity id, with its current proposal results ordered by proposal sequence number. A deleted output is not found.
 */
export const directvotingBeaconRuleOutputsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<DirectvotingBeaconRuleOutputsRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<
    DirectvotingBeaconRuleOutputsRetrieveResponses,
    DirectvotingBeaconRuleOutputsRetrieveErrors,
    ThrowOnError
  >({
    responseTransformer: directvotingBeaconRuleOutputsRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directvoting/beacon-rule-outputs/{identity_id}/',
    ...options,
  })

/**
 * Search Beacon rule outputs
 *
 * Lists the current version of every one of the acting tenant's Beacon rule outputs that is not deleted, ordered by creation time, each with its current proposal results ordered by proposal sequence number. The tenant is taken from the `X-Acting-Tenant` header, so another tenant's outputs are never returned. Filters (pi_ballot_id, proposal_set_id, refer_status) travel in the request body and combine with AND; an empty body returns every output the tenant has. Pagination uses the `cursor` and `page_size` query parameters.
 */
export const directvotingBeaconRuleOutputsSearchCreate = <ThrowOnError extends boolean = false>(
  options: Options<DirectvotingBeaconRuleOutputsSearchCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    DirectvotingBeaconRuleOutputsSearchCreateResponses,
    DirectvotingBeaconRuleOutputsSearchCreateErrors,
    ThrowOnError
  >({
    responseTransformer: directvotingBeaconRuleOutputsSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directvoting/beacon-rule-outputs/search/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Add a custody account to a custody account group
 *
 * Puts a custody account in one of the acting tenant's groups, opening the first version of the membership. The tenant is taken from the `X-Acting-Tenant` header; a group belonging to another tenant, a custody account linked to another tenant, and a custody account linked to no tenant are all rejected, as is an account already in the group. An account removed from the group earlier may be added again, and comes back as a new membership beside the closed one.
 */
export const directvotingCustodyAccountGroupMembershipsCreate = <ThrowOnError extends boolean = false>(
  options: Options<DirectvotingCustodyAccountGroupMembershipsCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    DirectvotingCustodyAccountGroupMembershipsCreateResponses,
    DirectvotingCustodyAccountGroupMembershipsCreateErrors,
    ThrowOnError
  >({
    responseTransformer: directvotingCustodyAccountGroupMembershipsCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directvoting/custody-account-group-memberships/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Remove a custody account from a custody account group
 *
 * Closes the membership's current version, leaving the identity and all version history in place. The account then no longer appears among the group's members, and the period it was one stays readable through the search endpoint's `include_removed`.
 */
export const directvotingCustodyAccountGroupMembershipsDestroy = <ThrowOnError extends boolean = false>(
  options: Options<DirectvotingCustodyAccountGroupMembershipsDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DirectvotingCustodyAccountGroupMembershipsDestroyResponses,
    DirectvotingCustodyAccountGroupMembershipsDestroyErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directvoting/custody-account-group-memberships/{identity_id}/',
    ...options,
  })

/**
 * Search custody account group memberships
 *
 * Lists the current memberships of the acting tenant's custody account groups, ordered by creation time. The tenant is taken from the `X-Acting-Tenant` header, so another tenant's memberships are never returned. Filters (group_id, custody_account_id) travel in the request body and combine with AND; an empty body returns every current membership the tenant has. Set `include_removed` to also return the closed versions, so a removed membership and a re-added one read as two periods. Pagination uses the `cursor` and `page_size` query parameters.
 */
export const directvotingCustodyAccountGroupMembershipsSearchCreate = <ThrowOnError extends boolean = false>(
  options: Options<DirectvotingCustodyAccountGroupMembershipsSearchCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    DirectvotingCustodyAccountGroupMembershipsSearchCreateResponses,
    DirectvotingCustodyAccountGroupMembershipsSearchCreateErrors,
    ThrowOnError
  >({
    responseTransformer: directvotingCustodyAccountGroupMembershipsSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directvoting/custody-account-group-memberships/search/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Create a custody account group
 *
 * Creates a group owned by the acting tenant, named by the `X-Acting-Tenant` header. The title must not already be used by another of that tenant's groups; another tenant using it is no obstacle.
 */
export const directvotingCustodyAccountGroupsCreate = <ThrowOnError extends boolean = false>(
  options: Options<DirectvotingCustodyAccountGroupsCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    DirectvotingCustodyAccountGroupsCreateResponses,
    DirectvotingCustodyAccountGroupsCreateErrors,
    ThrowOnError
  >({
    responseTransformer: directvotingCustodyAccountGroupsCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directvoting/custody-account-groups/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Delete a custody account group
 *
 * Deletes a group no custody account has ever been in. A group's membership history is kept, so once an account has been added to it the group can no longer be deleted, whether or not the account is still a member.
 */
export const directvotingCustodyAccountGroupsDestroy = <ThrowOnError extends boolean = false>(
  options: Options<DirectvotingCustodyAccountGroupsDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DirectvotingCustodyAccountGroupsDestroyResponses,
    DirectvotingCustodyAccountGroupsDestroyErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directvoting/custody-account-groups/{id}/',
    ...options,
  })

/**
 * Get a custody account group
 *
 * Lifecycle endpoints for the acting tenant's custody account groups.
 */
export const directvotingCustodyAccountGroupsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<DirectvotingCustodyAccountGroupsRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<
    DirectvotingCustodyAccountGroupsRetrieveResponses,
    DirectvotingCustodyAccountGroupsRetrieveErrors,
    ThrowOnError
  >({
    responseTransformer: directvotingCustodyAccountGroupsRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directvoting/custody-account-groups/{id}/',
    ...options,
  })

/**
 * Partially update a custody account group
 *
 * Lifecycle endpoints for the acting tenant's custody account groups.
 */
export const directvotingCustodyAccountGroupsPartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<DirectvotingCustodyAccountGroupsPartialUpdateData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    DirectvotingCustodyAccountGroupsPartialUpdateResponses,
    DirectvotingCustodyAccountGroupsPartialUpdateErrors,
    ThrowOnError
  >({
    responseTransformer: directvotingCustodyAccountGroupsPartialUpdateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directvoting/custody-account-groups/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Update a custody account group
 *
 * Lifecycle endpoints for the acting tenant's custody account groups.
 */
export const directvotingCustodyAccountGroupsUpdate = <ThrowOnError extends boolean = false>(
  options: Options<DirectvotingCustodyAccountGroupsUpdateData, ThrowOnError>
) =>
  (options.client ?? client).put<
    DirectvotingCustodyAccountGroupsUpdateResponses,
    DirectvotingCustodyAccountGroupsUpdateErrors,
    ThrowOnError
  >({
    responseTransformer: directvotingCustodyAccountGroupsUpdateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directvoting/custody-account-groups/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Search custody account groups
 *
 * Lists the acting tenant's custody account groups, ordered by creation time. The tenant is taken from the `X-Acting-Tenant` header, so another tenant's groups are never returned. The optional title filter travels in the request body and matches exactly; an empty body returns every group the tenant has. Pagination uses the `cursor` and `page_size` query parameters.
 */
export const directvotingCustodyAccountGroupsSearchCreate = <ThrowOnError extends boolean = false>(
  options: Options<DirectvotingCustodyAccountGroupsSearchCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    DirectvotingCustodyAccountGroupsSearchCreateResponses,
    DirectvotingCustodyAccountGroupsSearchCreateErrors,
    ThrowOnError
  >({
    responseTransformer: directvotingCustodyAccountGroupsSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directvoting/custody-account-groups/search/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * List custody account tenant links
 */
export const directvotingCustodyAccountTenantLinksList = <ThrowOnError extends boolean = false>(
  options?: Options<DirectvotingCustodyAccountTenantLinksListData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    DirectvotingCustodyAccountTenantLinksListResponses,
    DirectvotingCustodyAccountTenantLinksListErrors,
    ThrowOnError
  >({
    responseTransformer: directvotingCustodyAccountTenantLinksListResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directvoting/custody-account-tenant-links/',
    ...options,
  })

/**
 * Link a custody account to a tenant
 *
 * Link a custody account to the tenant that owns it. If the account is already linked to the same tenant the existing link is returned unchanged; linking it to a different tenant is rejected.
 */
export const directvotingCustodyAccountTenantLinksLinkCreate = <ThrowOnError extends boolean = false>(
  options: Options<DirectvotingCustodyAccountTenantLinksLinkCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    DirectvotingCustodyAccountTenantLinksLinkCreateResponses,
    DirectvotingCustodyAccountTenantLinksLinkCreateErrors,
    ThrowOnError
  >({
    responseTransformer: directvotingCustodyAccountTenantLinksLinkCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directvoting/custody-account-tenant-links/link/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Unlink a custody account from its tenant
 *
 * Remove the link between a custody account and its tenant.
 */
export const directvotingCustodyAccountTenantLinksUnlinkCreate = <ThrowOnError extends boolean = false>(
  options: Options<DirectvotingCustodyAccountTenantLinksUnlinkCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    DirectvotingCustodyAccountTenantLinksUnlinkCreateResponses,
    DirectvotingCustodyAccountTenantLinksUnlinkCreateErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directvoting/custody-account-tenant-links/unlink/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Create a custody account voting policy selection
 *
 * Creates the first version of a selection for a custody account. A custody account may have at most one current selection; creating a second is a conflict until the first is deleted.
 */
export const directvotingCustodyAccountVotingPolicySelectionsCreate = <ThrowOnError extends boolean = false>(
  options: Options<DirectvotingCustodyAccountVotingPolicySelectionsCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    DirectvotingCustodyAccountVotingPolicySelectionsCreateResponses,
    DirectvotingCustodyAccountVotingPolicySelectionsCreateErrors,
    ThrowOnError
  >({
    responseTransformer: directvotingCustodyAccountVotingPolicySelectionsCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directvoting/custody-account-voting-policy-selections/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Delete a custody account voting policy selection
 *
 * Closes the current version, leaving the identity and all version history in place. The selection then no longer appears in search or retrieve, and the custody account is free to be selected again.
 */
export const directvotingCustodyAccountVotingPolicySelectionsDestroy = <ThrowOnError extends boolean = false>(
  options: Options<DirectvotingCustodyAccountVotingPolicySelectionsDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DirectvotingCustodyAccountVotingPolicySelectionsDestroyResponses,
    DirectvotingCustodyAccountVotingPolicySelectionsDestroyErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directvoting/custody-account-voting-policy-selections/{identity_id}/',
    ...options,
  })

/**
 * Get a custody account voting policy selection
 *
 * Returns the current version of the selection addressed by its identity id.
 */
export const directvotingCustodyAccountVotingPolicySelectionsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<DirectvotingCustodyAccountVotingPolicySelectionsRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<
    DirectvotingCustodyAccountVotingPolicySelectionsRetrieveResponses,
    DirectvotingCustodyAccountVotingPolicySelectionsRetrieveErrors,
    ThrowOnError
  >({
    responseTransformer: directvotingCustodyAccountVotingPolicySelectionsRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directvoting/custody-account-voting-policy-selections/{identity_id}/',
    ...options,
  })

/**
 * Partially update a custody account voting policy selection
 *
 * Appends a new version with the supplied fields applied over the current one and closes the previous version. The custody account identifies the selection and cannot be changed; a different value is ignored. An unchanged write creates no new version.
 */
export const directvotingCustodyAccountVotingPolicySelectionsPartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<DirectvotingCustodyAccountVotingPolicySelectionsPartialUpdateData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    DirectvotingCustodyAccountVotingPolicySelectionsPartialUpdateResponses,
    DirectvotingCustodyAccountVotingPolicySelectionsPartialUpdateErrors,
    ThrowOnError
  >({
    responseTransformer: directvotingCustodyAccountVotingPolicySelectionsPartialUpdateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directvoting/custody-account-voting-policy-selections/{identity_id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Update a custody account voting policy selection
 *
 * Appends a new version carrying the supplied values and closes the previous one. The custody account identifies the selection and cannot be changed; a different value is ignored. An unchanged write creates no new version.
 */
export const directvotingCustodyAccountVotingPolicySelectionsUpdate = <ThrowOnError extends boolean = false>(
  options: Options<DirectvotingCustodyAccountVotingPolicySelectionsUpdateData, ThrowOnError>
) =>
  (options.client ?? client).put<
    DirectvotingCustodyAccountVotingPolicySelectionsUpdateResponses,
    DirectvotingCustodyAccountVotingPolicySelectionsUpdateErrors,
    ThrowOnError
  >({
    responseTransformer: directvotingCustodyAccountVotingPolicySelectionsUpdateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directvoting/custody-account-voting-policy-selections/{identity_id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Search custody account voting policy selections
 *
 * Lists the current version of every custody account voting policy selection that is not deleted. Filters (tenant_id, custody_account_id, voting_policy_id) travel in the request body and combine with AND; pagination uses the `cursor` and `page_size` query parameters.
 */
export const directvotingCustodyAccountVotingPolicySelectionsSearchCreate = <ThrowOnError extends boolean = false>(
  options?: Options<DirectvotingCustodyAccountVotingPolicySelectionsSearchCreateData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    DirectvotingCustodyAccountVotingPolicySelectionsSearchCreateResponses,
    DirectvotingCustodyAccountVotingPolicySelectionsSearchCreateErrors,
    ThrowOnError
  >({
    responseTransformer: directvotingCustodyAccountVotingPolicySelectionsSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directvoting/custody-account-voting-policy-selections/search/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Search the acting tenant's meetings for assignment
 *
 * List the proxy intermediary meetings the acting tenant can vote on, with the issuer and assignment each needs on the assignment page. The tenant is taken from the `X-Acting-Tenant` header. Only current, non-cancelled meeting versions are returned, each once. Filters travel in the request body and combine with AND; a filter on ballots matches a meeting when any of the tenant's ballots on it matches. Ordering defaults to meeting deadline ascending. Pagination uses the `cursor` and `page_size` query parameters.
 */
export const directvotingMeetingsAssignmentSearchCreate = <ThrowOnError extends boolean = false>(
  options: Options<DirectvotingMeetingsAssignmentSearchCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    DirectvotingMeetingsAssignmentSearchCreateResponses,
    DirectvotingMeetingsAssignmentSearchCreateErrors,
    ThrowOnError
  >({
    responseTransformer: directvotingMeetingsAssignmentSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directvoting/meetings/assignment/search/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Search the acting tenant's proxy intermediary meetings
 *
 * List the proxy intermediary meetings the acting tenant can vote on, resolved through the tenant's linked custody accounts. The tenant is taken from the `X-Acting-Tenant` header. Only current, non-cancelled meeting versions are returned, each once. Filters (search, proxy_intermediary_meeting_ids, deadline bounds) travel in the request body and combine with AND; ordering defaults to meeting deadline ascending. Pagination uses the `cursor` and `page_size` query parameters.
 */
export const directvotingMeetingsSearchCreate = <ThrowOnError extends boolean = false>(
  options: Options<DirectvotingMeetingsSearchCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    DirectvotingMeetingsSearchCreateResponses,
    DirectvotingMeetingsSearchCreateErrors,
    ThrowOnError
  >({
    responseTransformer: directvotingMeetingsSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directvoting/meetings/search/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Create a rule
 *
 * Creates a rule under one of the acting tenant's live rules lists, named by the `X-Acting-Tenant` header. `rule_type` says which parameter model and processor the engine applies, and `params` is stored as given; its contents are interpreted by the engine that evaluates the rule, not here. Titles are not unique within a list.
 */
export const directvotingRulesEngineRulesCreate = <ThrowOnError extends boolean = false>(
  options: Options<DirectvotingRulesEngineRulesCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    DirectvotingRulesEngineRulesCreateResponses,
    DirectvotingRulesEngineRulesCreateErrors,
    ThrowOnError
  >({
    responseTransformer: directvotingRulesEngineRulesCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directvoting/rules-engine/rules/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Create a rules list
 *
 * Creates a rules list owned by the acting tenant, named by the `X-Acting-Tenant` header. The title must not already be used by another of that tenant's live lists for the same rules engine; another tenant using it is no obstacle.
 */
export const directvotingRulesEngineRulesListsCreate = <ThrowOnError extends boolean = false>(
  options: Options<DirectvotingRulesEngineRulesListsCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    DirectvotingRulesEngineRulesListsCreateResponses,
    DirectvotingRulesEngineRulesListsCreateErrors,
    ThrowOnError
  >({
    responseTransformer: directvotingRulesEngineRulesListsCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directvoting/rules-engine/rules-lists/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Delete a rules list
 *
 * Closes the current version, leaving the identity and all version history in place. The list then no longer appears in search or retrieve, and its title is free to be used again. A list that still holds rules cannot be deleted; delete its rules first.
 */
export const directvotingRulesEngineRulesListsDestroy = <ThrowOnError extends boolean = false>(
  options: Options<DirectvotingRulesEngineRulesListsDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DirectvotingRulesEngineRulesListsDestroyResponses,
    DirectvotingRulesEngineRulesListsDestroyErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directvoting/rules-engine/rules-lists/{identity_id}/',
    ...options,
  })

/**
 * Get a rules list
 *
 * Lifecycle endpoints for the acting tenant's rules lists.
 */
export const directvotingRulesEngineRulesListsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<DirectvotingRulesEngineRulesListsRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<
    DirectvotingRulesEngineRulesListsRetrieveResponses,
    DirectvotingRulesEngineRulesListsRetrieveErrors,
    ThrowOnError
  >({
    responseTransformer: directvotingRulesEngineRulesListsRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directvoting/rules-engine/rules-lists/{identity_id}/',
    ...options,
  })

/**
 * Partially update a rules list
 *
 * Appends a new version carrying the supplied fields; the fields left out carry forward. The rules engine and the code are fixed for the life of the list, so a body naming either is rejected.
 */
export const directvotingRulesEngineRulesListsPartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<DirectvotingRulesEngineRulesListsPartialUpdateData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    DirectvotingRulesEngineRulesListsPartialUpdateResponses,
    DirectvotingRulesEngineRulesListsPartialUpdateErrors,
    ThrowOnError
  >({
    responseTransformer: directvotingRulesEngineRulesListsPartialUpdateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directvoting/rules-engine/rules-lists/{identity_id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Search rules lists
 *
 * Lists the current version of every one of the acting tenant's rules lists that is not deleted, ordered by creation time. The tenant is taken from the `X-Acting-Tenant` header, so another tenant's lists are never returned. Filters (rules_engine, title) travel in the request body and combine with AND; an empty body returns every list the tenant has. Pagination uses the `cursor` and `page_size` query parameters.
 */
export const directvotingRulesEngineRulesListsSearchCreate = <ThrowOnError extends boolean = false>(
  options: Options<DirectvotingRulesEngineRulesListsSearchCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    DirectvotingRulesEngineRulesListsSearchCreateResponses,
    DirectvotingRulesEngineRulesListsSearchCreateErrors,
    ThrowOnError
  >({
    responseTransformer: directvotingRulesEngineRulesListsSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directvoting/rules-engine/rules-lists/search/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Delete a rule
 *
 * Closes the current version, leaving the identity and all version history in place. The rule then no longer appears in search or retrieve, and no longer counts against deleting its list.
 */
export const directvotingRulesEngineRulesDestroy = <ThrowOnError extends boolean = false>(
  options: Options<DirectvotingRulesEngineRulesDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DirectvotingRulesEngineRulesDestroyResponses,
    DirectvotingRulesEngineRulesDestroyErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directvoting/rules-engine/rules/{identity_id}/',
    ...options,
  })

/**
 * Get a rule
 *
 * Lifecycle endpoints for the rules held by the acting tenant's rules lists.
 */
export const directvotingRulesEngineRulesRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<DirectvotingRulesEngineRulesRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<
    DirectvotingRulesEngineRulesRetrieveResponses,
    DirectvotingRulesEngineRulesRetrieveErrors,
    ThrowOnError
  >({
    responseTransformer: directvotingRulesEngineRulesRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directvoting/rules-engine/rules/{identity_id}/',
    ...options,
  })

/**
 * Partially update a rule
 *
 * Appends a new version carrying the supplied fields; the fields left out carry forward. The rules list and the code are fixed for the life of the rule, so a body naming either is rejected.
 */
export const directvotingRulesEngineRulesPartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<DirectvotingRulesEngineRulesPartialUpdateData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    DirectvotingRulesEngineRulesPartialUpdateResponses,
    DirectvotingRulesEngineRulesPartialUpdateErrors,
    ThrowOnError
  >({
    responseTransformer: directvotingRulesEngineRulesPartialUpdateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directvoting/rules-engine/rules/{identity_id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Search rules
 *
 * Lists the current version of every one of the acting tenant's rules that is not deleted, ordered by creation time. The tenant is taken from the `X-Acting-Tenant` header, so another tenant's rules are never returned. Filters (rules_list_id, rule_type) travel in the request body and combine with AND; an empty body returns every rule the tenant has. Pagination uses the `cursor` and `page_size` query parameters.
 */
export const directvotingRulesEngineRulesSearchCreate = <ThrowOnError extends boolean = false>(
  options: Options<DirectvotingRulesEngineRulesSearchCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    DirectvotingRulesEngineRulesSearchCreateResponses,
    DirectvotingRulesEngineRulesSearchCreateErrors,
    ThrowOnError
  >({
    responseTransformer: directvotingRulesEngineRulesSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directvoting/rules-engine/rules/search/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Add an issuer to a watchlist
 *
 * Puts an issuer on one of the acting tenant's live watchlists, opening the first version of the item. The tenant is taken from the `X-Acting-Tenant` header; a watchlist belonging to another tenant, a deleted watchlist and a deleted issuer are all rejected, as is an issuer already on the watchlist. An issuer removed from the watchlist earlier may be added again, and comes back as a new item beside the closed one.
 */
export const directvotingWatchlistItemsCreate = <ThrowOnError extends boolean = false>(
  options: Options<DirectvotingWatchlistItemsCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    DirectvotingWatchlistItemsCreateResponses,
    DirectvotingWatchlistItemsCreateErrors,
    ThrowOnError
  >({
    responseTransformer: directvotingWatchlistItemsCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directvoting/watchlist-items/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Remove an issuer from a watchlist
 *
 * Closes the item's current version, leaving the identity and all version history in place. The issuer then no longer appears on the watchlist. An item whose issuer has been deleted is not found.
 */
export const directvotingWatchlistItemsDestroy = <ThrowOnError extends boolean = false>(
  options: Options<DirectvotingWatchlistItemsDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DirectvotingWatchlistItemsDestroyResponses,
    DirectvotingWatchlistItemsDestroyErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directvoting/watchlist-items/{identity_id}/',
    ...options,
  })

/**
 * Get a watchlist item
 *
 * Returns one of the acting tenant's current watchlist items, by identity id. An item whose issuer has been deleted is not found.
 */
export const directvotingWatchlistItemsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<DirectvotingWatchlistItemsRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<
    DirectvotingWatchlistItemsRetrieveResponses,
    DirectvotingWatchlistItemsRetrieveErrors,
    ThrowOnError
  >({
    responseTransformer: directvotingWatchlistItemsRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directvoting/watchlist-items/{identity_id}/',
    ...options,
  })

/**
 * Add many issuers to a watchlist
 *
 * Puts every named issuer on one of the acting tenant's live watchlists, all or nothing. An issuer already on the watchlist keeps its current item and appends no version; any other issuer gets a new item. A repeated issuer id is ignored, and the response lists one item per distinct issuer in the order the request first named it. Every issuer must exist and not be deleted; the 400 names each one that fails.
 */
export const directvotingWatchlistItemsBatchCreate = <ThrowOnError extends boolean = false>(
  options: Options<DirectvotingWatchlistItemsBatchCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    DirectvotingWatchlistItemsBatchCreateResponses,
    DirectvotingWatchlistItemsBatchCreateErrors,
    ThrowOnError
  >({
    responseTransformer: directvotingWatchlistItemsBatchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directvoting/watchlist-items/batch/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Search watchlist items
 *
 * Lists the current items on the acting tenant's watchlists, ordered by creation time. The tenant is taken from the `X-Acting-Tenant` header, so another tenant's items are never returned, and an item whose issuer has been deleted is left out. Filters (watchlist_id, issuer_id) travel in the request body and combine with AND; an empty body returns every current item the tenant has. Pagination uses the `cursor` and `page_size` query parameters.
 */
export const directvotingWatchlistItemsSearchCreate = <ThrowOnError extends boolean = false>(
  options: Options<DirectvotingWatchlistItemsSearchCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    DirectvotingWatchlistItemsSearchCreateResponses,
    DirectvotingWatchlistItemsSearchCreateErrors,
    ThrowOnError
  >({
    responseTransformer: directvotingWatchlistItemsSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directvoting/watchlist-items/search/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Create a watchlist
 *
 * Creates a watchlist owned by the acting tenant, named by the `X-Acting-Tenant` header. The title must not already be used by another of that tenant's live watchlists; another tenant using it is no obstacle, and neither is a deleted watchlist. The code is generated by the server, so a body naming it is rejected.
 */
export const directvotingWatchlistsCreate = <ThrowOnError extends boolean = false>(
  options: Options<DirectvotingWatchlistsCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    DirectvotingWatchlistsCreateResponses,
    DirectvotingWatchlistsCreateErrors,
    ThrowOnError
  >({
    responseTransformer: directvotingWatchlistsCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directvoting/watchlists/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Delete a watchlist
 *
 * Closes the current version and removes every issuer on the watchlist, leaving the identities and all version history in place. The watchlist and its items then no longer appear in search or retrieve, and its title is free to be used again.
 */
export const directvotingWatchlistsDestroy = <ThrowOnError extends boolean = false>(
  options: Options<DirectvotingWatchlistsDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DirectvotingWatchlistsDestroyResponses,
    DirectvotingWatchlistsDestroyErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directvoting/watchlists/{identity_id}/',
    ...options,
  })

/**
 * Get a watchlist
 *
 * Returns the current version of one of the acting tenant's live watchlists, by identity id.
 */
export const directvotingWatchlistsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<DirectvotingWatchlistsRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<
    DirectvotingWatchlistsRetrieveResponses,
    DirectvotingWatchlistsRetrieveErrors,
    ThrowOnError
  >({
    responseTransformer: directvotingWatchlistsRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directvoting/watchlists/{identity_id}/',
    ...options,
  })

/**
 * Partially update a watchlist
 *
 * Appends a new version carrying the supplied fields; the fields left out carry forward, and a body that changes nothing appends no version. Send `description: null` to clear the description. The code is fixed for the life of the watchlist, so a body naming it is rejected.
 */
export const directvotingWatchlistsPartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<DirectvotingWatchlistsPartialUpdateData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    DirectvotingWatchlistsPartialUpdateResponses,
    DirectvotingWatchlistsPartialUpdateErrors,
    ThrowOnError
  >({
    responseTransformer: directvotingWatchlistsPartialUpdateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directvoting/watchlists/{identity_id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Search watchlists
 *
 * Lists the current version of every one of the acting tenant's watchlists that is not deleted, ordered by creation time. The tenant is taken from the `X-Acting-Tenant` header, so another tenant's watchlists are never returned. The title filter travels in the request body; an empty body returns every watchlist the tenant has. Pagination uses the `cursor` and `page_size` query parameters.
 */
export const directvotingWatchlistsSearchCreate = <ThrowOnError extends boolean = false>(
  options: Options<DirectvotingWatchlistsSearchCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    DirectvotingWatchlistsSearchCreateResponses,
    DirectvotingWatchlistsSearchCreateErrors,
    ThrowOnError
  >({
    responseTransformer: directvotingWatchlistsSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directvoting/watchlists/search/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Create a fund manager
 */
export const fundManagerFundManagersCreate = <ThrowOnError extends boolean = false>(
  options: Options<FundManagerFundManagersCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<FundManagerFundManagersCreateResponses, unknown, ThrowOnError>({
    responseTransformer: fundManagerFundManagersCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/fund-manager/fund-managers/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Fetch a fund manager's policies
 *
 * Returns all policy PDFs for a fund manager, each with a 24-hour presigned URL. The list is not paginated. Returns 404 if the fund manager does not exist.
 */
export const fundManagerFundManagersPoliciesRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<FundManagerFundManagersPoliciesRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<FundManagerFundManagersPoliciesRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: fundManagerFundManagersPoliciesRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/fund-manager/fund-managers/{fund_manager_id}/policies/',
    ...options,
  })

/**
 * Upload a fund manager policy
 *
 * Uploads a policy PDF for a fund manager. The request body must be the raw PDF file with Content-Type: application/pdf, and the filename query parameter becomes the policy title (without the '.pdf' extension). The file must be smaller than 10,000,000 bytes. Returns 404 if the fund manager does not exist, and 400 for a non-'.pdf' filename or an oversized body.
 */
export const fundManagerFundManagersPoliciesCreate = <ThrowOnError extends boolean = false>(
  options: Options<FundManagerFundManagersPoliciesCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<FundManagerFundManagersPoliciesCreateResponses, unknown, ThrowOnError>({
    bodySerializer: null,
    responseTransformer: fundManagerFundManagersPoliciesCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/fund-manager/fund-managers/{fund_manager_id}/policies/',
    ...options,
    headers: {
      'Content-Type': 'application/pdf',
      ...options.headers,
    },
  })

/**
 * Get a fund manager
 */
export const fundManagerFundManagersRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<FundManagerFundManagersRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<FundManagerFundManagersRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: fundManagerFundManagersRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/fund-manager/fund-managers/{id}/',
    ...options,
  })

/**
 * Update a fund manager
 */
export const fundManagerFundManagersUpdate = <ThrowOnError extends boolean = false>(
  options: Options<FundManagerFundManagersUpdateData, ThrowOnError>
) =>
  (options.client ?? client).put<FundManagerFundManagersUpdateResponses, unknown, ThrowOnError>({
    responseTransformer: fundManagerFundManagersUpdateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/fund-manager/fund-managers/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Search fund managers
 *
 * Search fund managers with filters supplied in the request body. Filters that may contain large, unbounded collections (e.g. names, relationship_owners) are sent in the body to avoid overflowing URL-length limits. Pagination uses the `cursor` and `page_size` query parameters.
 */
export const fundManagerFundManagersSearchCreate = <ThrowOnError extends boolean = false>(
  options?: Options<FundManagerFundManagersSearchCreateData, ThrowOnError>
) =>
  (options?.client ?? client).post<FundManagerFundManagersSearchCreateResponses, unknown, ThrowOnError>({
    responseTransformer: fundManagerFundManagersSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/fund-manager/fund-managers/search/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Create a fund variant
 *
 * Creates a fund variant under the given parent fund. Public security IDs that don't yet exist are created automatically; custom security IDs must already exist. The fund variant must reference at least one public or custom security ID, and cash security IDs are rejected.
 */
export const fundManagerFundVariantsCreate = <ThrowOnError extends boolean = false>(
  options: Options<FundManagerFundVariantsCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<FundManagerFundVariantsCreateResponses, unknown, ThrowOnError>({
    responseTransformer: fundManagerFundVariantsCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/fund-manager/fund-variants/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Delete a fund variant
 *
 * Deletes a fund variant, unlinking any security IDs that reference it.
 */
export const fundManagerFundVariantsDestroy = <ThrowOnError extends boolean = false>(
  options: Options<FundManagerFundVariantsDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<FundManagerFundVariantsDestroyResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/fund-manager/fund-variants/{id}/',
    ...options,
  })

/**
 * Get a fund variant
 *
 * Returns a single fund variant by its id.
 */
export const fundManagerFundVariantsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<FundManagerFundVariantsRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<FundManagerFundVariantsRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: fundManagerFundVariantsRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/fund-manager/fund-variants/{id}/',
    ...options,
  })

/**
 * Update a fund variant
 *
 * Updates a fund variant's title, cfi and linked security IDs. Supplying a different `fund_name` reparents the variant onto that fund. Security IDs already linked to another variant are rejected with 409.
 */
export const fundManagerFundVariantsUpdate = <ThrowOnError extends boolean = false>(
  options: Options<FundManagerFundVariantsUpdateData, ThrowOnError>
) =>
  (options.client ?? client).put<FundManagerFundVariantsUpdateResponses, unknown, ThrowOnError>({
    responseTransformer: fundManagerFundVariantsUpdateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/fund-manager/fund-variants/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Search fund variants
 *
 * Search fund variants with filters supplied in the request body. The parent fund filter is optional: omit `fund_name` to search across all funds (the wildcard parent 'funds/-'). Results are ordered by fund id, title, id. Pagination uses the `cursor` and `page_size` query parameters.
 */
export const fundManagerFundVariantsSearchCreate = <ThrowOnError extends boolean = false>(
  options?: Options<FundManagerFundVariantsSearchCreateData, ThrowOnError>
) =>
  (options?.client ?? client).post<FundManagerFundVariantsSearchCreateResponses, unknown, ThrowOnError>({
    responseTransformer: fundManagerFundVariantsSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/fund-manager/fund-variants/search/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Create a fund
 *
 * Creates a fund, including any proxy intermediary account identifiers supplied with it.
 */
export const fundManagerFundsCreate = <ThrowOnError extends boolean = false>(
  options: Options<FundManagerFundsCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<FundManagerFundsCreateResponses, unknown, ThrowOnError>({
    responseTransformer: fundManagerFundsCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/fund-manager/funds/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Create a fund quantification snapshot
 *
 * Creates an immutable fund quantification snapshot under the given fund, including the quantifications of the fund's variants supplied with it.
 */
export const fundManagerFundsQuantificationSnapshotsCreate = <ThrowOnError extends boolean = false>(
  options: Options<FundManagerFundsQuantificationSnapshotsCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<FundManagerFundsQuantificationSnapshotsCreateResponses, unknown, ThrowOnError>({
    responseTransformer: fundManagerFundsQuantificationSnapshotsCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/fund-manager/funds/{fund_id}/quantification-snapshots/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Get a fund
 *
 * Returns a fund. When the optional `product` query parameter is supplied, the fund is only returned if it belongs to that product; otherwise a 404 is returned.
 */
export const fundManagerFundsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<FundManagerFundsRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<FundManagerFundsRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: fundManagerFundsRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/fund-manager/funds/{id}/',
    ...options,
  })

/**
 * Update a fund
 *
 * Updates a fund. The product and fund manager of a fund cannot be changed. When proxy intermediary identifiers are supplied, the fund's proxy intermediary accounts are synced to match them; when omitted (or null), existing accounts are left untouched.
 */
export const fundManagerFundsUpdate = <ThrowOnError extends boolean = false>(
  options: Options<FundManagerFundsUpdateData, ThrowOnError>
) =>
  (options.client ?? client).put<FundManagerFundsUpdateResponses, unknown, ThrowOnError>({
    responseTransformer: fundManagerFundsUpdateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/fund-manager/funds/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Search funds
 *
 * Search funds with filters supplied in the request body. Filters that may contain large, unbounded collections (e.g. names, external_ids, account ids) are sent in the body to avoid overflowing URL-length limits. Results are ordered by create time descending, id descending. Pagination uses the `cursor` and `page_size` query parameters.
 */
export const fundManagerFundsSearchCreate = <ThrowOnError extends boolean = false>(
  options: Options<FundManagerFundsSearchCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<FundManagerFundsSearchCreateResponses, unknown, ThrowOnError>({
    responseTransformer: fundManagerFundsSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/fund-manager/funds/search/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * List providers
 */
export const fundManagerProvidersList = <ThrowOnError extends boolean = false>(
  options?: Options<FundManagerProvidersListData, ThrowOnError>
) =>
  (options?.client ?? client).get<FundManagerProvidersListResponses, unknown, ThrowOnError>({
    responseTransformer: fundManagerProvidersListResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/fund-manager/providers/',
    ...options,
  })

/**
 * Create a provider
 */
export const fundManagerProvidersCreate = <ThrowOnError extends boolean = false>(
  options: Options<FundManagerProvidersCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<FundManagerProvidersCreateResponses, unknown, ThrowOnError>({
    responseTransformer: fundManagerProvidersCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/fund-manager/providers/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Get a provider
 */
export const fundManagerProvidersRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<FundManagerProvidersRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<FundManagerProvidersRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: fundManagerProvidersRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/fund-manager/providers/{id}/',
    ...options,
  })

/**
 * Update a provider
 */
export const fundManagerProvidersUpdate = <ThrowOnError extends boolean = false>(
  options: Options<FundManagerProvidersUpdateData, ThrowOnError>
) =>
  (options.client ?? client).put<FundManagerProvidersUpdateResponses, unknown, ThrowOnError>({
    responseTransformer: fundManagerProvidersUpdateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/fund-manager/providers/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Create a public security ID
 *
 * Creates a public security ID from its name. Creation is idempotent: an existing public security ID with the same name is returned unchanged.
 */
export const fundManagerPublicSecurityIdsCreate = <ThrowOnError extends boolean = false>(
  options: Options<FundManagerPublicSecurityIdsCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<FundManagerPublicSecurityIdsCreateResponses, unknown, ThrowOnError>({
    responseTransformer: fundManagerPublicSecurityIdsCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/fund-manager/public-security-ids/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Search public security IDs
 *
 * Search public security IDs with filters supplied in the request body. Filters that may contain large, unbounded collections (e.g. names, values) are sent in the body to avoid overflowing URL-length limits. Results are ordered by security type ascending, value ascending. Pagination uses the `cursor` and `page_size` query parameters.
 */
export const fundManagerPublicSecurityIdsSearchCreate = <ThrowOnError extends boolean = false>(
  options?: Options<FundManagerPublicSecurityIdsSearchCreateData, ThrowOnError>
) =>
  (options?.client ?? client).post<FundManagerPublicSecurityIdsSearchCreateResponses, unknown, ThrowOnError>({
    responseTransformer: fundManagerPublicSecurityIdsSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/fund-manager/public-security-ids/search/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Search fund quantification snapshots
 *
 * Search fund quantification snapshots with filters supplied in the request body. Filters that may contain large, unbounded collections (e.g. names, fund_names) are sent in the body to avoid overflowing URL-length limits. Results are ordered by valid time descending, id descending. Pagination uses the `cursor` and `page_size` query parameters.
 */
export const fundManagerQuantificationSnapshotsSearchCreate = <ThrowOnError extends boolean = false>(
  options: Options<FundManagerQuantificationSnapshotsSearchCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<FundManagerQuantificationSnapshotsSearchCreateResponses, unknown, ThrowOnError>({
    responseTransformer: fundManagerQuantificationSnapshotsSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/fund-manager/quantification-snapshots/search/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * List meetings with filtering and cursor pagination.
 */
export const institutionalMeetingsearchList = <ThrowOnError extends boolean = false>(
  options: Options<InstitutionalMeetingsearchListData, ThrowOnError>
) =>
  (options.client ?? client).get<InstitutionalMeetingsearchListResponses, unknown, ThrowOnError>({
    responseTransformer: institutionalMeetingsearchListResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/institutional/meetingsearch',
    ...options,
  })

/**
 * Upsert a fiscal year
 *
 * Create a fiscal year, or append a new version of the one already held for that issuer and period end. Fields left out of the request carry forward from the current version, and a request that changes nothing leaves the period untouched. Preliminary figures are ignored once final figures are held for the period, and nothing is written. Returns the period's stable id and what happened to it.
 */
export const issuerFiscalYearsCreate = <ThrowOnError extends boolean = false>(
  options: Options<IssuerFiscalYearsCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<IssuerFiscalYearsCreateResponses, IssuerFiscalYearsCreateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/issuer/fiscal-years/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Search fiscal years
 *
 * Lists the current version of every fiscal year held for one issuer, newest period first. The issuer is named by exactly one of its identity id or its LSEG OrgPermID, and a request naming both or neither is rejected. An issuer that is not held returns 404, so an empty page always means the issuer holds no fiscal years rather than that the id was mistyped.
 */
export const issuerFiscalYearsSearchCreate = <ThrowOnError extends boolean = false>(
  options?: Options<IssuerFiscalYearsSearchCreateData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    IssuerFiscalYearsSearchCreateResponses,
    IssuerFiscalYearsSearchCreateErrors,
    ThrowOnError
  >({
    responseTransformer: issuerFiscalYearsSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/issuer/fiscal-years/search/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Upsert an instrument
 *
 * Create an instrument, or append a new version of an existing one identified by its identifier, the kind of identifier and the issuer. Fields left out of the request carry forward from the current version. The share count and total shareholder return are each optional and are written against the date they are valid for; an identical measure for a date already held is left alone. A return names the exchange it was measured on, which must already be known by its ISO 10383 MIC code, and nothing is written if it is not. Returns the instrument's stable id and what happened to each of the three.
 */
export const issuerInstrumentsCreate = <ThrowOnError extends boolean = false>(
  options: Options<IssuerInstrumentsCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<IssuerInstrumentsCreateResponses, IssuerInstrumentsCreateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/issuer/instruments/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Get an instrument
 *
 * Returns the current version of the instrument with this identity id. A deleted instrument returns 404.
 */
export const issuerInstrumentsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<IssuerInstrumentsRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<IssuerInstrumentsRetrieveResponses, IssuerInstrumentsRetrieveErrors, ThrowOnError>({
    responseTransformer: issuerInstrumentsRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/issuer/instruments/{identity_id}/',
    ...options,
  })

/**
 * Get an instrument's shares outstanding
 *
 * Returns the latest share count held for the instrument, valid on or before valid_at. This is a single-valued measure, so an instrument holding none on or before that date returns 404 rather than an empty body, and a request that gave valid_at has that bound named in the message.
 */
export const issuerInstrumentsOutstandingSharesRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<IssuerInstrumentsOutstandingSharesRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<
    IssuerInstrumentsOutstandingSharesRetrieveResponses,
    IssuerInstrumentsOutstandingSharesRetrieveErrors,
    ThrowOnError
  >({
    responseTransformer: issuerInstrumentsOutstandingSharesRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/issuer/instruments/{identity_id}/outstanding-shares/',
    ...options,
  })

/**
 * Upsert an instrument's shares outstanding
 *
 * Write the instrument's share count for the date it is valid for, without touching the instrument itself. One measure is held per instrument and valid date: a first write for a date creates it, a changed value overwrites it, and an identical redelivery leaves it alone. Measures for other dates are untouched. An instrument that is not held, or is deleted, returns 404. Returns what happened to the measure.
 */
export const issuerInstrumentsOutstandingSharesCreate = <ThrowOnError extends boolean = false>(
  options: Options<IssuerInstrumentsOutstandingSharesCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    IssuerInstrumentsOutstandingSharesCreateResponses,
    IssuerInstrumentsOutstandingSharesCreateErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/issuer/instruments/{identity_id}/outstanding-shares/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Get an instrument's total shareholder return
 *
 * Returns the latest total shareholder return per exchange the instrument trades on, valid on or before valid_at. The return is held per venue, so unlike the single-valued measures this one is a collection: an instrument with no return on a matching exchange returns 200 with an empty list rather than 404. An exchange code that is not held is rejected with 400, so an empty list always means the instrument holds no return rather than that the code was mistyped.
 */
export const issuerInstrumentsTotalShareholderReturnRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<IssuerInstrumentsTotalShareholderReturnRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<
    IssuerInstrumentsTotalShareholderReturnRetrieveResponses,
    IssuerInstrumentsTotalShareholderReturnRetrieveErrors,
    ThrowOnError
  >({
    responseTransformer: issuerInstrumentsTotalShareholderReturnRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/issuer/instruments/{identity_id}/total-shareholder-return/',
    ...options,
  })

/**
 * Upsert an instrument's total shareholder return
 *
 * Write the instrument's total shareholder return on one exchange for the date it is valid for, without touching the instrument itself. One measure is held per instrument, exchange and valid date: a first write for that combination creates it, a changed value, currency or return index overwrites it, and an identical redelivery leaves it alone. The row is replaced rather than merged, so a return index left out of the request clears a stored one. Returns for other exchanges and other dates are untouched. The exchange must already be known by its ISO 10383 MIC code, and nothing is written if it is not. An instrument that is not held, or is deleted, returns 404. Returns what happened to the measure.
 */
export const issuerInstrumentsTotalShareholderReturnCreate = <ThrowOnError extends boolean = false>(
  options: Options<IssuerInstrumentsTotalShareholderReturnCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    IssuerInstrumentsTotalShareholderReturnCreateResponses,
    IssuerInstrumentsTotalShareholderReturnCreateErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/issuer/instruments/{identity_id}/total-shareholder-return/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Search instruments
 *
 * Lists the current version of every instrument that is not deleted, filters combining with AND. identifiers and identifier_type are sent together and match instruments holding one of those identifiers of that kind.
 */
export const issuerInstrumentsSearchCreate = <ThrowOnError extends boolean = false>(
  options?: Options<IssuerInstrumentsSearchCreateData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    IssuerInstrumentsSearchCreateResponses,
    IssuerInstrumentsSearchCreateErrors,
    ThrowOnError
  >({
    responseTransformer: issuerInstrumentsSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/issuer/instruments/search/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Upsert an issuer
 *
 * Create an issuer, or append a new version of an existing one identified by its LSEG OrgPermID. Fields left out of the request carry forward from the current version, and a request that changes nothing leaves the issuer untouched. A named primary listing exchange must already be known by its ISO 10383 MIC code. Returns the issuer's stable id and whether it was created, versioned, or left unchanged.
 */
export const issuerIssuersCreate = <ThrowOnError extends boolean = false>(
  options: Options<IssuerIssuersCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<IssuerIssuersCreateResponses, IssuerIssuersCreateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/issuer/issuers/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Get an issuer
 *
 * Returns the current version of the issuer with this identity id. A deleted issuer returns 404.
 */
export const issuerIssuersRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<IssuerIssuersRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<IssuerIssuersRetrieveResponses, IssuerIssuersRetrieveErrors, ThrowOnError>({
    responseTransformer: issuerIssuersRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/issuer/issuers/{identity_id}/',
    ...options,
  })

/**
 * Get an issuer's market capitalisation
 *
 * Returns the latest market capitalisation held for the issuer, valid on or before valid_at. The figure is consolidated across the issuer's common share classes, which is why it is held on the issuer rather than an instrument. This is a single-valued measure, so an issuer holding none on or before that date returns 404 rather than an empty body, and a request that gave valid_at has that bound named in the message.
 */
export const issuerIssuersMarketCapitalisationRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<IssuerIssuersMarketCapitalisationRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<
    IssuerIssuersMarketCapitalisationRetrieveResponses,
    IssuerIssuersMarketCapitalisationRetrieveErrors,
    ThrowOnError
  >({
    responseTransformer: issuerIssuersMarketCapitalisationRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/issuer/issuers/{identity_id}/market-capitalisation/',
    ...options,
  })

/**
 * Upsert an issuer's market capitalisation
 *
 * Write the issuer's market capitalisation for the date it is valid for, without touching the issuer itself, so a backfill can restate the measure without versioning the issuer. One measure is held per issuer and valid date: a first write for a date creates it, a changed value or currency overwrites it, and an identical redelivery leaves it alone. Measures for other dates are untouched. An issuer that is not held, or is deleted, returns 404. Returns what happened to the measure.
 */
export const issuerIssuersMarketCapitalisationCreate = <ThrowOnError extends boolean = false>(
  options: Options<IssuerIssuersMarketCapitalisationCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    IssuerIssuersMarketCapitalisationCreateResponses,
    IssuerIssuersMarketCapitalisationCreateErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/issuer/issuers/{identity_id}/market-capitalisation/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Search issuers
 *
 * Lists the current version of every issuer that is not deleted, filters combining with AND; a blank search is ignored. Pages are ordered by display name then identity id, with issuers that have no display name last. The next and previous links carry no request body, so repeat the same filters when following them.
 */
export const issuerIssuersSearchCreate = <ThrowOnError extends boolean = false>(
  options?: Options<IssuerIssuersSearchCreateData, ThrowOnError>
) =>
  (options?.client ?? client).post<IssuerIssuersSearchCreateResponses, IssuerIssuersSearchCreateErrors, ThrowOnError>({
    responseTransformer: issuerIssuersSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/issuer/issuers/search/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * List ballot versions
 *
 * Return every version of the ballot identity, most recently written version first. Each version carries its own deadlines where they exist. Returns 404 if the ballot does not exist. Pagination uses the `cursor` and `page_size` query parameters.
 */
export const proxyIntermediaryBallotsVersionsList = <ThrowOnError extends boolean = false>(
  options: Options<ProxyIntermediaryBallotsVersionsListData, ThrowOnError>
) =>
  (options.client ?? client).get<ProxyIntermediaryBallotsVersionsListResponses, unknown, ThrowOnError>({
    responseTransformer: proxyIntermediaryBallotsVersionsListResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxy-intermediary/ballots/{ballot_id}/versions/',
    ...options,
  })

/**
 * Fetch ballots by version ids
 *
 * Return ballots by their version ids. Unknown version ids are silently ignored.
 */
export const proxyIntermediaryBallotsFetchByVersionIdsCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyIntermediaryBallotsFetchByVersionIdsCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<ProxyIntermediaryBallotsFetchByVersionIdsCreateResponses, unknown, ThrowOnError>({
    responseTransformer: proxyIntermediaryBallotsFetchByVersionIdsCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxy-intermediary/ballots/fetch-by-version-ids/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * List Proxymity ballots with a stale proposal set
 *
 * Return the current, uncancelled Proxymity ballots whose proposal_set_id is not their meeting's latest proposal set (the set with the most recent create_time), including ballots with no set on a meeting that has one. A meeting with no proposal sets never makes its ballots stale, and cancelled ballots are left out because Proxymity no longer re-lists them. Pagination uses the `cursor` and `page_size` query parameters.
 */
export const proxyIntermediaryBallotsProxymityStaleProposalSetList = <ThrowOnError extends boolean = false>(
  options?: Options<ProxyIntermediaryBallotsProxymityStaleProposalSetListData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    ProxyIntermediaryBallotsProxymityStaleProposalSetListResponses,
    unknown,
    ThrowOnError
  >({
    responseTransformer: proxyIntermediaryBallotsProxymityStaleProposalSetListResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxy-intermediary/ballots/proxymity-stale-proposal-set/',
    ...options,
  })

/**
 * Search ballots
 *
 * List proxy intermediary ballots matching the supplied filters. Filters travel in the request body to avoid overflowing URL-length limits on unbounded collections; pagination uses the `cursor` and `page_size` query parameters. Absent or empty filters return all current ballots.
 */
export const proxyIntermediaryBallotsSearchCreate = <ThrowOnError extends boolean = false>(
  options?: Options<ProxyIntermediaryBallotsSearchCreateData, ThrowOnError>
) =>
  (options?.client ?? client).post<ProxyIntermediaryBallotsSearchCreateResponses, unknown, ThrowOnError>({
    responseTransformer: proxyIntermediaryBallotsSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxy-intermediary/ballots/search/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Upsert a ballot
 *
 * Create or update a proxy intermediary ballot. The ballot is versioned bi-temporally: the latest visible ballot is the one with the most recent valid_time, and an upsert with no content changes returns STATUS_BALLOT_NO_OPERATION. Returns 404 if the proxy intermediary meeting does not exist and 400 if the request is invalid. Every upsert publishes a ballot event once the write has committed; a failure to publish returns 500 even though the write succeeded, so callers must be able to retry the same upsert.
 */
export const proxyIntermediaryBallotsUpsertCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyIntermediaryBallotsUpsertCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<ProxyIntermediaryBallotsUpsertCreateResponses, unknown, ThrowOnError>({
    responseTransformer: proxyIntermediaryBallotsUpsertCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxy-intermediary/ballots/upsert/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Create a custody account
 */
export const proxyIntermediaryCustodyAccountsCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyIntermediaryCustodyAccountsCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ProxyIntermediaryCustodyAccountsCreateResponses,
    ProxyIntermediaryCustodyAccountsCreateErrors,
    ThrowOnError
  >({
    responseTransformer: proxyIntermediaryCustodyAccountsCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxy-intermediary/custody-accounts/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Delete a custody account
 */
export const proxyIntermediaryCustodyAccountsDestroy = <ThrowOnError extends boolean = false>(
  options: Options<ProxyIntermediaryCustodyAccountsDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    ProxyIntermediaryCustodyAccountsDestroyResponses,
    ProxyIntermediaryCustodyAccountsDestroyErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxy-intermediary/custody-accounts/{id}/',
    ...options,
  })

/**
 * Get a custody account
 */
export const proxyIntermediaryCustodyAccountsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<ProxyIntermediaryCustodyAccountsRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ProxyIntermediaryCustodyAccountsRetrieveResponses,
    ProxyIntermediaryCustodyAccountsRetrieveErrors,
    ThrowOnError
  >({
    responseTransformer: proxyIntermediaryCustodyAccountsRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxy-intermediary/custody-accounts/{id}/',
    ...options,
  })

/**
 * Partially update a custody account
 */
export const proxyIntermediaryCustodyAccountsPartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyIntermediaryCustodyAccountsPartialUpdateData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    ProxyIntermediaryCustodyAccountsPartialUpdateResponses,
    ProxyIntermediaryCustodyAccountsPartialUpdateErrors,
    ThrowOnError
  >({
    responseTransformer: proxyIntermediaryCustodyAccountsPartialUpdateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxy-intermediary/custody-accounts/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Update a custody account
 */
export const proxyIntermediaryCustodyAccountsUpdate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyIntermediaryCustodyAccountsUpdateData, ThrowOnError>
) =>
  (options.client ?? client).put<
    ProxyIntermediaryCustodyAccountsUpdateResponses,
    ProxyIntermediaryCustodyAccountsUpdateErrors,
    ThrowOnError
  >({
    responseTransformer: proxyIntermediaryCustodyAccountsUpdateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxy-intermediary/custody-accounts/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Search custody accounts
 *
 * Lists custody accounts ordered by creation time. Filters (proxy_intermediary_id, custodian_id, custodian_account_number) travel in the request body and combine with AND; an empty body returns all custody accounts. Pagination uses the `cursor` and `page_size` query parameters.
 */
export const proxyIntermediaryCustodyAccountsSearchCreate = <ThrowOnError extends boolean = false>(
  options?: Options<ProxyIntermediaryCustodyAccountsSearchCreateData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    ProxyIntermediaryCustodyAccountsSearchCreateResponses,
    ProxyIntermediaryCustodyAccountsSearchCreateErrors,
    ThrowOnError
  >({
    responseTransformer: proxyIntermediaryCustodyAccountsSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxy-intermediary/custody-accounts/search/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Upsert a category to a proposal
 *
 * Create or update the category of a proxy intermediary proposal. Re-sending an unchanged category is a no-op; `status` reports whether it was created, updated or left unchanged. Returns 400 for an invalid body, 403 without a write role and 404 when the proposal does not exist.
 */
export const proxyIntermediaryPiProposalCategoriesUpsertCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyIntermediaryPiProposalCategoriesUpsertCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<ProxyIntermediaryPiProposalCategoriesUpsertCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxy-intermediary/pi-proposal-categories/upsert/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Assign a category to a proposal
 *
 * Assigns a proxy intermediary's free-text category to a transparency proposal, creating the category if none exists for the (proxy intermediary, proposal) pair or updating it otherwise.
 */
export const proxyIntermediaryProposalCategoriesAssignCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyIntermediaryProposalCategoriesAssignCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<ProxyIntermediaryProposalCategoriesAssignCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxy-intermediary/proposal-categories/assign/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * List categories for proposals
 *
 * Lists the proposal categories matching the given proxy intermediaries and transparency proposals. Filters are sent in the request body to avoid overflowing URL-length limits.
 */
export const proxyIntermediaryProposalCategoriesListCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyIntermediaryProposalCategoriesListCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<ProxyIntermediaryProposalCategoriesListCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxy-intermediary/proposal-categories/list/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Assign a label to a proposal
 *
 * Assigns a proxy intermediary's label to a transparency proposal. An empty label deletes any existing label for the proposal; a non-empty label creates or updates it. The label must be unique per (proxy intermediary, transparency general meeting) pair.
 */
export const proxyIntermediaryProposalLabelsAssignCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyIntermediaryProposalLabelsAssignCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<ProxyIntermediaryProposalLabelsAssignCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxy-intermediary/proposal-labels/assign/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Fetch labels for proposals
 *
 * Fetches the labels and categories for the given transparency proposals and proxy intermediary. Proposals without a label are omitted from the response maps. Proposal names are sent in the request body to avoid overflowing URL-length limits.
 */
export const proxyIntermediaryProposalLabelsFetchCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyIntermediaryProposalLabelsFetchCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<ProxyIntermediaryProposalLabelsFetchCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxy-intermediary/proposal-labels/fetch/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Fetch the latest proposal set for a Broadridge agenda
 *
 * Fetch the id of the most recent proposal set sourced from the given Broadridge agenda. Each update to an agenda is written as a new set carrying the same agenda id, so an agenda accumulates a set per revision and the newest one is returned. Returns 404 when no proposals were sourced from the agenda.
 */
export const proxyIntermediaryProposalsBroadridgeProposalSetFetchLatestCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyIntermediaryProposalsBroadridgeProposalSetFetchLatestCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ProxyIntermediaryProposalsBroadridgeProposalSetFetchLatestCreateResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxy-intermediary/proposals/broadridge-proposal-set/fetch-latest/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Create a proxy intermediary proposal set
 *
 * Create a set of proxy intermediary proposals atomically. The set is identified by a SHA-256 hash of its proposals; all proposals must belong to the same meeting. Returns 409 when a set with the same hash already exists.
 */
export const proxyIntermediaryProposalsCreateCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyIntermediaryProposalsCreateCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<ProxyIntermediaryProposalsCreateCreateResponses, unknown, ThrowOnError>({
    responseTransformer: proxyIntermediaryProposalsCreateCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxy-intermediary/proposals/create/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Delete a proxy intermediary proposal set
 *
 * Delete every proposal in the set identified by `proposal_set_id`. All proposals in the set are removed atomically. Returns 404 when no proposals exist for the set.
 */
export const proxyIntermediaryProposalsDeleteCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyIntermediaryProposalsDeleteCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<ProxyIntermediaryProposalsDeleteCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxy-intermediary/proposals/delete/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Fetch the latest proposal set for a Proxymity meeting
 *
 * Fetch the id of the most recent proposal set for the Proxymity meeting with the given external id. Proxymity sends a meeting's whole agenda in each notification, so an amended agenda is written as a new set for the same meeting and the newest one is returned. Returns 404 when Proxymity has no current meeting with that external id or the meeting has no proposal sets.
 */
export const proxyIntermediaryProposalsProxymityProposalSetFetchLatestCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyIntermediaryProposalsProxymityProposalSetFetchLatestCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ProxyIntermediaryProposalsProxymityProposalSetFetchLatestCreateResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxy-intermediary/proposals/proxymity-proposal-set/fetch-latest/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Search proxy intermediary proposals
 *
 * Search proxy intermediary proposals with filters supplied in the request body. When multiple filters are present they are combined with AND. Set `exclude_withdrawn` to leave out proposals the proxy intermediary reported as withdrawn. Results are ordered by creation time. Pagination uses the `cursor` and `page_size` query parameters.
 */
export const proxyIntermediaryProposalsSearchCreate = <ThrowOnError extends boolean = false>(
  options?: Options<ProxyIntermediaryProposalsSearchCreateData, ThrowOnError>
) =>
  (options?.client ?? client).post<ProxyIntermediaryProposalsSearchCreateResponses, unknown, ThrowOnError>({
    responseTransformer: proxyIntermediaryProposalsSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxy-intermediary/proposals/search/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Search proxy intermediaries
 *
 * Search proxy intermediaries with filters supplied in the request body. Filters that may contain large, unbounded collections (names, titles) are sent in the body to avoid overflowing URL-length limits. Absent or empty filters return all proxy intermediaries. Pagination uses the `cursor` and `page_size` query parameters.
 */
export const proxyIntermediaryProxyIntermediariesSearchCreate = <ThrowOnError extends boolean = false>(
  options?: Options<ProxyIntermediaryProxyIntermediariesSearchCreateData, ThrowOnError>
) =>
  (options?.client ?? client).post<ProxyIntermediaryProxyIntermediariesSearchCreateResponses, unknown, ThrowOnError>({
    responseTransformer: proxyIntermediaryProxyIntermediariesSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxy-intermediary/proxy-intermediaries/search/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Search proxy intermediary meeting audit events
 *
 * Search audit events for proxy intermediary meetings. Either `audit_event_names` or `entity_name` must be supplied. Results are ordered by creation time descending. Pagination uses the `cursor` and `page_size` query parameters.
 */
export const proxyIntermediaryProxyIntermediaryMeetingsAuditEventsSearchCreate = <ThrowOnError extends boolean = false>(
  options?: Options<ProxyIntermediaryProxyIntermediaryMeetingsAuditEventsSearchCreateData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    ProxyIntermediaryProxyIntermediaryMeetingsAuditEventsSearchCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseTransformer: proxyIntermediaryProxyIntermediaryMeetingsAuditEventsSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxy-intermediary/proxy-intermediary-meetings/audit-events/search/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Cancel proxy intermediary meetings
 *
 * Cancel a batch of meetings by resource name. Every named meeting must have a current, non-cancelled version, otherwise the whole batch is rejected.
 */
export const proxyIntermediaryProxyIntermediaryMeetingsCancelCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyIntermediaryProxyIntermediaryMeetingsCancelCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ProxyIntermediaryProxyIntermediaryMeetingsCancelCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseTransformer: proxyIntermediaryProxyIntermediaryMeetingsCancelCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxy-intermediary/proxy-intermediary-meetings/cancel/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Delete a proxy intermediary meeting outright
 *
 * Delete a meeting and every row held against it: its ballots and their deadlines, its proposals, its securities, every version of it, and its audit events. Returns how many rows of each were deleted, all zero when the intermediary has no meeting with that external id, so it can be called repeatedly. An investor's entitlement to vote, and the ballot handed out to them from it, reference a deleted ballot by id and are left behind. Available only where destructive endpoints are enabled, which is dev.
 */
export const proxyIntermediaryProxyIntermediaryMeetingsHardDeleteCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyIntermediaryProxyIntermediaryMeetingsHardDeleteCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ProxyIntermediaryProxyIntermediaryMeetingsHardDeleteCreateResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxy-intermediary/proxy-intermediary-meetings/hard-delete/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Link a meeting to a transparency general meeting
 *
 * Set the transparency general meeting a proxy intermediary meeting is linked to. The transparency general meeting must exist. Recomputes ballot deadlines for the meeting.
 */
export const proxyIntermediaryProxyIntermediaryMeetingsLinkTransparencyGeneralMeetingCreate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ProxyIntermediaryProxyIntermediaryMeetingsLinkTransparencyGeneralMeetingCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ProxyIntermediaryProxyIntermediaryMeetingsLinkTransparencyGeneralMeetingCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseTransformer:
      proxyIntermediaryProxyIntermediaryMeetingsLinkTransparencyGeneralMeetingCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxy-intermediary/proxy-intermediary-meetings/link-transparency-general-meeting/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Search proxy intermediary meetings
 *
 * Search the current version of proxy intermediary meetings with filters supplied in the request body. Filters that may contain large collections are sent in the body to avoid overflowing URL-length limits. Results are ordered by submission deadline. Pagination uses the `cursor` and `page_size` query parameters.
 */
export const proxyIntermediaryProxyIntermediaryMeetingsSearchCreate = <ThrowOnError extends boolean = false>(
  options?: Options<ProxyIntermediaryProxyIntermediaryMeetingsSearchCreateData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    ProxyIntermediaryProxyIntermediaryMeetingsSearchCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseTransformer: proxyIntermediaryProxyIntermediaryMeetingsSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxy-intermediary/proxy-intermediary-meetings/search/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Unlink a meeting from its transparency general meeting
 *
 * Clear the transparency general meeting a proxy intermediary meeting is linked to.
 */
export const proxyIntermediaryProxyIntermediaryMeetingsUnlinkTransparencyGeneralMeetingCreate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ProxyIntermediaryProxyIntermediaryMeetingsUnlinkTransparencyGeneralMeetingCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ProxyIntermediaryProxyIntermediaryMeetingsUnlinkTransparencyGeneralMeetingCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseTransformer:
      proxyIntermediaryProxyIntermediaryMeetingsUnlinkTransparencyGeneralMeetingCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxy-intermediary/proxy-intermediary-meetings/unlink-transparency-general-meeting/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Upsert a proxy intermediary meeting
 *
 * Create a meeting, or update the current version of an existing one identified by its proxy intermediary and external id. An empty update mask updates all patchable fields. Returns the resulting meeting and whether it was created, updated, or left unchanged.
 */
export const proxyIntermediaryProxyIntermediaryMeetingsUpsertCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyIntermediaryProxyIntermediaryMeetingsUpsertCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ProxyIntermediaryProxyIntermediaryMeetingsUpsertCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseTransformer: proxyIntermediaryProxyIntermediaryMeetingsUpsertCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxy-intermediary/proxy-intermediary-meetings/upsert/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Create a ProxyEdge vote
 *
 * Record a fund manager's vote instruction submitted through ProxyEdge. Instructions are appended rather than updated: the current instruction for a ballot control number is the one with the most recent valid_time. Returns 400 if the request is invalid, which includes the vote directions for an agenda resolution summing to more than the instructed balance.
 */
export const proxyIntermediaryProxyedgeVotesCreateCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyIntermediaryProxyedgeVotesCreateCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<ProxyIntermediaryProxyedgeVotesCreateCreateResponses, unknown, ThrowOnError>({
    responseTransformer: proxyIntermediaryProxyedgeVotesCreateCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxy-intermediary/proxyedge-votes/create/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Fetch the latest ProxyEdge vote
 *
 * Return the vote instruction with the most recent valid_time for a ballot control number. Returns 400 if the request is invalid, and 404 if no instruction carries this ballot control number.
 */
export const proxyIntermediaryProxyedgeVotesFetchLatestCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyIntermediaryProxyedgeVotesFetchLatestCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<ProxyIntermediaryProxyedgeVotesFetchLatestCreateResponses, unknown, ThrowOnError>({
    responseTransformer: proxyIntermediaryProxyedgeVotesFetchLatestCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxy-intermediary/proxyedge-votes/fetch-latest/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Create a Proxymity vote
 *
 * Record a fund manager's vote instruction submitted through Proxymity. Instructions are appended rather than updated: the current instruction for a single instruction id is the one with the most recent valid_time. Returns 400 if the request is invalid, which includes the vote directions for an agenda resolution summing to more than the instructed balance.
 */
export const proxyIntermediaryProxymityVotesCreateCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyIntermediaryProxymityVotesCreateCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<ProxyIntermediaryProxymityVotesCreateCreateResponses, unknown, ThrowOnError>({
    responseTransformer: proxyIntermediaryProxymityVotesCreateCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxy-intermediary/proxymity-votes/create/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Fetch the latest Proxymity vote
 *
 * Return the vote instruction with the most recent valid_time for a single instruction id. Returns 400 if the request is invalid, and 404 if no instruction carries this single instruction id.
 */
export const proxyIntermediaryProxymityVotesFetchLatestCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyIntermediaryProxymityVotesFetchLatestCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<ProxyIntermediaryProxymityVotesFetchLatestCreateResponses, unknown, ThrowOnError>({
    responseTransformer: proxyIntermediaryProxymityVotesFetchLatestCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxy-intermediary/proxymity-votes/fetch-latest/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Delete a vote status
 *
 * Retract a vote status so it is no longer visible, by setting its delete time. Retracting an already-retracted status keeps the original delete time. Returns 400 if the id is malformed and 404 if no vote status has this id.
 */
export const proxyIntermediaryVoteStatusesDeleteCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyIntermediaryVoteStatusesDeleteCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<ProxyIntermediaryVoteStatusesDeleteCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxy-intermediary/vote-statuses/delete/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Upsert a vote status
 *
 * Record the status a proxy intermediary reports for a ballot's votes. Statuses are appended rather than updated: the visible status is the one with the most recent valid_time, and an upsert whose vote_status and status_note are unchanged returns STATUS_VOTE_STATUS_NO_OPERATION without writing. Returns 400 if the request is invalid, 422 if the proxy intermediary does not exist, and 409 if the status collides with one already recorded.
 */
export const proxyIntermediaryVoteStatusesUpsertCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyIntermediaryVoteStatusesUpsertCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<ProxyIntermediaryVoteStatusesUpsertCreateResponses, unknown, ThrowOnError>({
    responseTransformer: proxyIntermediaryVoteStatusesUpsertCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxy-intermediary/vote-statuses/upsert/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * List ballot entitlements
 *
 * Returns ballot entitlements, optionally filtered by proxy_intermediary_ballot_id or investor_account_id. By default, only active entitlements (invalid_time is null) are returned. Set include_invalid=true to include invalidated entitlements.
 */
export const proxyvotingEntitlementsList = <ThrowOnError extends boolean = false>(
  options?: Options<ProxyvotingEntitlementsListData, ThrowOnError>
) =>
  (options?.client ?? client).get<ProxyvotingEntitlementsListResponses, unknown, ThrowOnError>({
    responseTransformer: proxyvotingEntitlementsListResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/entitlements',
    ...options,
  })

/**
 * Compute ballot breakdown synchronously
 *
 * Computes the ballot breakdown for a proxy intermediary ballot with specified filters. Returns the full graph structure in JSON format. This is a synchronous operation.
 */
export const proxyvotingEntitlementsBreakdownCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyvotingEntitlementsBreakdownCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<ProxyvotingEntitlementsBreakdownCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/entitlements/breakdown',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Trigger entitlements computation
 *
 * Enqueues an entitlements computation task to run asynchronously. Returns task_id to check status
 */
export const proxyvotingEntitlementsComputeCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyvotingEntitlementsComputeCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<ProxyvotingEntitlementsComputeCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/entitlements:compute',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Update Fund Manager Supported Issued Instruments
 *
 * Updates a fund manager's Supported Issued Instruments for the given voting policies and ISINs. Adds new instruments and invalidates existing instruments not in the provided list.
 */
export const proxyvotingFundManagerCompositionsSiiFromCompositionDifferenceCreate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ProxyvotingFundManagerCompositionsSiiFromCompositionDifferenceCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ProxyvotingFundManagerCompositionsSiiFromCompositionDifferenceCreateResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/fund-manager/compositions/sii/from-composition-difference',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Batch create fund manager policy supported issued instruments
 *
 * Creates fund manager policy supported issued instruments for the given fund manager and voting policy. Instruments that already exist are silently ignored (no-op).
 */
export const proxyvotingFundManagerPolicySupportedIssuedInstrumentsCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyvotingFundManagerPolicySupportedIssuedInstrumentsCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ProxyvotingFundManagerPolicySupportedIssuedInstrumentsCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseTransformer: proxyvotingFundManagerPolicySupportedIssuedInstrumentsCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/fund-manager/policy-supported-issued-instruments',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Batch delete fund manager policy supported issued instruments
 *
 * Soft-deletes fund manager policy supported issued instruments by name (sets delete_time and valid_to).
 */
export const proxyvotingFundManagerPolicySupportedIssuedInstrumentsBatchDeleteCreate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ProxyvotingFundManagerPolicySupportedIssuedInstrumentsBatchDeleteCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ProxyvotingFundManagerPolicySupportedIssuedInstrumentsBatchDeleteCreateResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/fund-manager/policy-supported-issued-instruments/batch-delete',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Search fund manager policy supported issued instruments
 *
 * Search fund manager policy supported issued instruments with filters supplied in the request body. Filters that may contain large, unbounded collections (e.g. fund_manager_names, voting_policy_names, public_security_id_names) are sent in the body to avoid overflowing URL-length limits. Pagination uses the `cursor` and `page_size` query parameters.
 */
export const proxyvotingFundManagerPolicySupportedIssuedInstrumentsSearchCreate = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ProxyvotingFundManagerPolicySupportedIssuedInstrumentsSearchCreateData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    ProxyvotingFundManagerPolicySupportedIssuedInstrumentsSearchCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseTransformer: proxyvotingFundManagerPolicySupportedIssuedInstrumentsSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/fund-manager/policy-supported-issued-instruments/search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * List fund manager supported policies
 *
 * Returns all fund manager / voting policy links, optionally filtered. Supply as_of to fetch the historical state at a specific point in time.
 */
export const proxyvotingFundManagerSupportedPoliciesList = <ThrowOnError extends boolean = false>(
  options?: Options<ProxyvotingFundManagerSupportedPoliciesListData, ThrowOnError>
) =>
  (options?.client ?? client).get<ProxyvotingFundManagerSupportedPoliciesListResponses, unknown, ThrowOnError>({
    responseTransformer: proxyvotingFundManagerSupportedPoliciesListResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/fund-manager/supported-policies',
    ...options,
  })

/**
 * Batch upsert fund manager supported policies
 *
 * Creates or ensures existence of fund manager / voting policy links. All upserts are applied atomically.
 */
export const proxyvotingFundManagerSupportedPoliciesCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyvotingFundManagerSupportedPoliciesCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<ProxyvotingFundManagerSupportedPoliciesCreateResponses, unknown, ThrowOnError>({
    responseTransformer: proxyvotingFundManagerSupportedPoliciesCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/fund-manager/supported-policies',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Delete a fund manager supported policy
 *
 * Deletes the fund manager / voting policy link with the given ID.
 */
export const proxyvotingFundManagerSupportedPoliciesDestroy = <ThrowOnError extends boolean = false>(
  options: Options<ProxyvotingFundManagerSupportedPoliciesDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<ProxyvotingFundManagerSupportedPoliciesDestroyResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/fund-manager/supported-policies/{id}',
    ...options,
  })

/**
 * Get composition differences
 *
 * Fetches and compares investor compositions between two time periods
 */
export const proxyvotingInvestorCompositionsDifferenceList = <ThrowOnError extends boolean = false>(
  options: Options<ProxyvotingInvestorCompositionsDifferenceListData, ThrowOnError>
) =>
  (options.client ?? client).get<ProxyvotingInvestorCompositionsDifferenceListResponses, unknown, ThrowOnError>({
    responseTransformer: proxyvotingInvestorCompositionsDifferenceListResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/investor/compositions/difference',
    ...options,
  })

export const proxyvotingInvestorCompositionsRenderCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyvotingInvestorCompositionsRenderCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<ProxyvotingInvestorCompositionsRenderCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/investor/compositions/render',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Get investor rules engine mapping
 *
 * Retrieves the rules engine mapping for a specific investor. Requires vops.administrator role.
 */
export const proxyvotingInvestorCompositionsRulesEngineRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<ProxyvotingInvestorCompositionsRulesEngineRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<ProxyvotingInvestorCompositionsRulesEngineRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: proxyvotingInvestorCompositionsRulesEngineRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/investor/compositions/rules-engine',
    ...options,
  })

/**
 * Map investor to rules engine
 *
 * Upserts mapping between an investor and their voting rules engine. Returns 201 for new mappings, 200 for updates. Requires vops.administrator role.
 */
export const proxyvotingInvestorCompositionsRulesEngineUpdate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyvotingInvestorCompositionsRulesEngineUpdateData, ThrowOnError>
) =>
  (options.client ?? client).put<ProxyvotingInvestorCompositionsRulesEngineUpdateResponses, unknown, ThrowOnError>({
    responseTransformer: proxyvotingInvestorCompositionsRulesEngineUpdateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/investor/compositions/rules-engine',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Update Supported Issued Instruments from composition difference
 *
 * Updates an investor's Supported Issued Instruments based on a provided composition difference. Adds new instruments and invalidates removed instruments.
 */
export const proxyvotingInvestorCompositionsSiiFromCompositionDifferenceCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyvotingInvestorCompositionsSiiFromCompositionDifferenceCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ProxyvotingInvestorCompositionsSiiFromCompositionDifferenceCreateResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/investor/compositions/sii/from-composition-difference',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Batch create investor policy supported issued instruments
 *
 * Creates investor policy supported issued instruments for the given investor and voting policy. Instruments that already exist are silently ignored (no-op).
 */
export const proxyvotingInvestorPolicySupportedIssuedInstrumentsCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyvotingInvestorPolicySupportedIssuedInstrumentsCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ProxyvotingInvestorPolicySupportedIssuedInstrumentsCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseTransformer: proxyvotingInvestorPolicySupportedIssuedInstrumentsCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/investor/policy-supported-issued-instruments',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Batch delete investor policy supported issued instruments
 *
 * Soft-deletes investor policy supported issued instruments by name (sets delete_time and valid_to).
 */
export const proxyvotingInvestorPolicySupportedIssuedInstrumentsBatchDeleteCreate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ProxyvotingInvestorPolicySupportedIssuedInstrumentsBatchDeleteCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ProxyvotingInvestorPolicySupportedIssuedInstrumentsBatchDeleteCreateResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/investor/policy-supported-issued-instruments/batch-delete',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Search investor policy supported issued instruments
 *
 * Search investor policy supported issued instruments with filters supplied in the request body. Filters that may contain large, unbounded collections (e.g. investor_names, voting_policy_names, public_security_id_names) are sent in the body to avoid overflowing URL-length limits. Pagination uses the `cursor` and `page_size` query parameters.
 */
export const proxyvotingInvestorPolicySupportedIssuedInstrumentsSearchCreate = <ThrowOnError extends boolean = false>(
  options?: Options<ProxyvotingInvestorPolicySupportedIssuedInstrumentsSearchCreateData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    ProxyvotingInvestorPolicySupportedIssuedInstrumentsSearchCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseTransformer: proxyvotingInvestorPolicySupportedIssuedInstrumentsSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/investor/policy-supported-issued-instruments/search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Batch create investor supported issued instruments
 *
 * Creates investor supported issued instruments for the given investor. Instruments that already exist are silently ignored (no-op).
 */
export const proxyvotingInvestorSupportedIssuedInstrumentsCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyvotingInvestorSupportedIssuedInstrumentsCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<ProxyvotingInvestorSupportedIssuedInstrumentsCreateResponses, unknown, ThrowOnError>({
    responseTransformer: proxyvotingInvestorSupportedIssuedInstrumentsCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/investor/supported-issued-instruments',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Batch delete investor supported issued instruments
 *
 * Soft-deletes investor supported issued instruments by name (sets delete_time and valid_to).
 */
export const proxyvotingInvestorSupportedIssuedInstrumentsBatchDeleteCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyvotingInvestorSupportedIssuedInstrumentsBatchDeleteCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ProxyvotingInvestorSupportedIssuedInstrumentsBatchDeleteCreateResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/investor/supported-issued-instruments/batch-delete',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Search investor supported issued instruments
 *
 * Search investor supported issued instruments with filters supplied in the request body. Filters that may contain large, unbounded collections (e.g. investor_names, public_security_id_names) are sent in the body to avoid overflowing URL-length limits. Pagination uses the `cursor` and `page_size` query parameters.
 */
export const proxyvotingInvestorSupportedIssuedInstrumentsSearchCreate = <ThrowOnError extends boolean = false>(
  options?: Options<ProxyvotingInvestorSupportedIssuedInstrumentsSearchCreateData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    ProxyvotingInvestorSupportedIssuedInstrumentsSearchCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseTransformer: proxyvotingInvestorSupportedIssuedInstrumentsSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/investor/supported-issued-instruments/search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * List meeting ballot sources
 *
 * Returns meeting ballot sources, optionally filtered by meeting_ballot_id or proxy_intermediary_ballot_id. By default, only active sources (invalid_time is null) are returned. Set include_invalid=true to include invalidated sources.
 */
export const proxyvotingMeetingBallotSourcesList = <ThrowOnError extends boolean = false>(
  options?: Options<ProxyvotingMeetingBallotSourcesListData, ThrowOnError>
) =>
  (options?.client ?? client).get<ProxyvotingMeetingBallotSourcesListResponses, unknown, ThrowOnError>({
    responseTransformer: proxyvotingMeetingBallotSourcesListResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/meeting-ballot-sources',
    ...options,
  })

/**
 * List meeting ballots
 *
 * Returns meeting ballots, optionally filtered by investor_id or general_meeting_id.
 */
export const proxyvotingMeetingBallotsList = <ThrowOnError extends boolean = false>(
  options?: Options<ProxyvotingMeetingBallotsListData, ThrowOnError>
) =>
  (options?.client ?? client).get<ProxyvotingMeetingBallotsListResponses, unknown, ThrowOnError>({
    responseTransformer: proxyvotingMeetingBallotsListResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/meeting-ballots',
    ...options,
  })

/**
 * Trigger meeting ballot handout processing
 *
 * Enqueues a meeting ballot handout task to run asynchronously. Returns task_id to check status
 */
export const proxyvotingMeetingballotsComputeCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyvotingMeetingballotsComputeCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<ProxyvotingMeetingballotsComputeCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/meetingballots:compute',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Filter proxy intermediary ballot search results with cursor-based pagination.
 */
export const proxyvotingPiballotsFilterList = <ThrowOnError extends boolean = false>(
  options?: Options<ProxyvotingPiballotsFilterListData, ThrowOnError>
) =>
  (options?.client ?? client).get<ProxyvotingPiballotsFilterListResponses, unknown, ThrowOnError>({
    responseTransformer: proxyvotingPiballotsFilterListResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/piballots/filter',
    ...options,
  })

/**
 * Compute investor accounts who can vote on ballots, and whether investigation is required the ballot
 *
 * For each provided ballot ID, returns the number of investor accounts expected to vote, their individual fund proportions, and whether the ballot requires investigation due to potentially missing or inaccurate entitlements data.
 */
export const proxyvotingPiballotsInvestorsCanVoteCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyvotingPiballotsInvestorsCanVoteCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<ProxyvotingPiballotsInvestorsCanVoteCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/piballots/investors-can-vote',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Filter proxy intermediary meeting search results with cursor-based pagination. Returns meetings that are in scope for voting operations workflow, along with their scope information.
 */
export const proxyvotingPimeetingsFilterList = <ThrowOnError extends boolean = false>(
  options?: Options<ProxyvotingPimeetingsFilterListData, ThrowOnError>
) =>
  (options?.client ?? client).get<ProxyvotingPimeetingsFilterListResponses, unknown, ThrowOnError>({
    responseTransformer: proxyvotingPimeetingsFilterListResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/pimeetings/filter',
    ...options,
  })

/**
 * List rules engine definitions
 *
 * Returns all rules engine definition versions, optionally filtered by name.
 */
export const proxyvotingRulesEngineDefinitionsList = <ThrowOnError extends boolean = false>(
  options?: Options<ProxyvotingRulesEngineDefinitionsListData, ThrowOnError>
) =>
  (options?.client ?? client).get<ProxyvotingRulesEngineDefinitionsListResponses, unknown, ThrowOnError>({
    responseTransformer: proxyvotingRulesEngineDefinitionsListResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/rules-engine-definitions',
    ...options,
  })

/**
 * Create a rules engine definition
 *
 * Creates a new rules engine definition version.
 */
export const proxyvotingRulesEngineDefinitionsCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyvotingRulesEngineDefinitionsCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<ProxyvotingRulesEngineDefinitionsCreateResponses, unknown, ThrowOnError>({
    responseTransformer: proxyvotingRulesEngineDefinitionsCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/rules-engine-definitions',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * List rules for a definition
 *
 * Returns all rules for the given rules engine definition, ordered by rule order.
 */
export const proxyvotingRulesEngineDefinitionsRulesList = <ThrowOnError extends boolean = false>(
  options: Options<ProxyvotingRulesEngineDefinitionsRulesListData, ThrowOnError>
) =>
  (options.client ?? client).get<ProxyvotingRulesEngineDefinitionsRulesListResponses, unknown, ThrowOnError>({
    responseTransformer: proxyvotingRulesEngineDefinitionsRulesListResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/rules-engine-definitions/{definition_id}/rules',
    ...options,
  })

/**
 * Create a rule
 *
 * Creates a new rule within the given rules engine definition.
 */
export const proxyvotingRulesEngineDefinitionsRulesCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyvotingRulesEngineDefinitionsRulesCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<ProxyvotingRulesEngineDefinitionsRulesCreateResponses, unknown, ThrowOnError>({
    responseTransformer: proxyvotingRulesEngineDefinitionsRulesCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/rules-engine-definitions/{definition_id}/rules',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Delete a rule
 *
 * Deletes the rule with the given ID within the given definition.
 */
export const proxyvotingRulesEngineDefinitionsRulesDestroy = <ThrowOnError extends boolean = false>(
  options: Options<ProxyvotingRulesEngineDefinitionsRulesDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<ProxyvotingRulesEngineDefinitionsRulesDestroyResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/rules-engine-definitions/{definition_id}/rules/{id}',
    ...options,
  })

/**
 * Update a rule
 *
 * Replaces all fields of the rule with the given ID within the given definition.
 */
export const proxyvotingRulesEngineDefinitionsRulesUpdate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyvotingRulesEngineDefinitionsRulesUpdateData, ThrowOnError>
) =>
  (options.client ?? client).put<ProxyvotingRulesEngineDefinitionsRulesUpdateResponses, unknown, ThrowOnError>({
    responseTransformer: proxyvotingRulesEngineDefinitionsRulesUpdateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/rules-engine-definitions/{definition_id}/rules/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Delete a rules engine definition
 *
 * Deletes the definition with the given ID and its associated rules. Returns 409 if this is the last definition for its name — use DELETE /rules-engine-definitions/by-name/{name} to delete the engine entirely.
 */
export const proxyvotingRulesEngineDefinitionsDestroy = <ThrowOnError extends boolean = false>(
  options: Options<ProxyvotingRulesEngineDefinitionsDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    ProxyvotingRulesEngineDefinitionsDestroyResponses,
    ProxyvotingRulesEngineDefinitionsDestroyErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/rules-engine-definitions/{id}',
    ...options,
  })

/**
 * Retrieve a rules engine definition
 *
 * Returns the rules engine definition with the given ID.
 */
export const proxyvotingRulesEngineDefinitionsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<ProxyvotingRulesEngineDefinitionsRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<ProxyvotingRulesEngineDefinitionsRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: proxyvotingRulesEngineDefinitionsRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/rules-engine-definitions/{id}',
    ...options,
  })

/**
 * Delete all definitions for a name
 *
 * Deletes all versioned definitions with the given name and their associated rules. Returns 409 if the name is the Tumelo base engine or if any investor is configured to use this rules engine. Returns 404 if no definitions exist with the given name.
 */
export const proxyvotingRulesEngineDefinitionsByNameDestroy = <ThrowOnError extends boolean = false>(
  options: Options<ProxyvotingRulesEngineDefinitionsByNameDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    ProxyvotingRulesEngineDefinitionsByNameDestroyResponses,
    ProxyvotingRulesEngineDefinitionsByNameDestroyErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/rules-engine-definitions/by-name/{name}',
    ...options,
  })

/**
 * List rules engine names
 *
 * Returns the distinct names of all rules engines, sorted alphabetically. Use this to render a list of available rules engines before fetching their versions.
 */
export const proxyvotingRulesEngineDefinitionsNamesRetrieve = <ThrowOnError extends boolean = false>(
  options?: Options<ProxyvotingRulesEngineDefinitionsNamesRetrieveData, ThrowOnError>
) =>
  (options?.client ?? client).get<ProxyvotingRulesEngineDefinitionsNamesRetrieveResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/rules-engine-definitions/names',
    ...options,
  })

/**
 * Create a new Split Vote Instruction Proposal Overwrite.
 */
export const proxyvotingSviProposalOverwriteCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyvotingSviProposalOverwriteCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<ProxyvotingSviProposalOverwriteCreateResponses, unknown, ThrowOnError>({
    responseTransformer: proxyvotingSviProposalOverwriteCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/svi/proposal/overwrite',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Retrieve a list of Split Vote Instruction Overwrite Reasons.
 */
export const proxyvotingSviProposalOverwriteReasonsList = <ThrowOnError extends boolean = false>(
  options?: Options<ProxyvotingSviProposalOverwriteReasonsListData, ThrowOnError>
) =>
  (options?.client ?? client).get<ProxyvotingSviProposalOverwriteReasonsListResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/svi/proposal/overwrite/reasons',
    ...options,
  })

/**
 * Submit a split vote instruction's votes
 *
 * Submit the votes of a split vote instruction against a proxy intermediary ballot and record the submission. Per-resolution votes are rounded to whole shares (0.5 rounds up) and any live vote overwrite is applied before submission. The call is synchronous: a submission the proxy intermediary rejects also writes a rejected acknowledgement, returned on the submission. Returns 400 if either resource name is malformed, 404 if the ballot or instruction does not exist, and 422 if the ballot's proxy intermediary does not support vote submission or a voted proposal has no proposal label.
 */
export const proxyvotingSviSubmitVoteCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyvotingSviSubmitVoteCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<ProxyvotingSviSubmitVoteCreateResponses, unknown, ThrowOnError>({
    responseTransformer: proxyvotingSviSubmitVoteCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/svi/submit-vote',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Create a permission group
 *
 * Creates a permission group owned by the acting tenant, named by the `X-Acting-Tenant` header. The name must not already be used by another of that tenant's groups; another tenant using it is no obstacle.
 */
export const tenancyPermissionGroupsCreate = <ThrowOnError extends boolean = false>(
  options: Options<TenancyPermissionGroupsCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    TenancyPermissionGroupsCreateResponses,
    TenancyPermissionGroupsCreateErrors,
    ThrowOnError
  >({
    responseTransformer: tenancyPermissionGroupsCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenancy/permission-groups/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Delete a permission group
 *
 * Lifecycle endpoints for the acting tenant's permission groups.
 */
export const tenancyPermissionGroupsDestroy = <ThrowOnError extends boolean = false>(
  options: Options<TenancyPermissionGroupsDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    TenancyPermissionGroupsDestroyResponses,
    TenancyPermissionGroupsDestroyErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenancy/permission-groups/{permission_group_id}/',
    ...options,
  })

/**
 * Update a permission group
 *
 * Replaces the group's name, description and permissions.
 */
export const tenancyPermissionGroupsUpdate = <ThrowOnError extends boolean = false>(
  options: Options<TenancyPermissionGroupsUpdateData, ThrowOnError>
) =>
  (options.client ?? client).put<
    TenancyPermissionGroupsUpdateResponses,
    TenancyPermissionGroupsUpdateErrors,
    ThrowOnError
  >({
    responseTransformer: tenancyPermissionGroupsUpdateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenancy/permission-groups/{permission_group_id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Create a role
 *
 * Creates a role owned by the acting tenant, named by the `X-Acting-Tenant` header. The name must not already be used by another of that tenant's roles; another tenant using it is no obstacle.
 */
export const tenancyRolesCreate = <ThrowOnError extends boolean = false>(
  options: Options<TenancyRolesCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<TenancyRolesCreateResponses, TenancyRolesCreateErrors, ThrowOnError>({
    responseTransformer: tenancyRolesCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenancy/roles/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Delete a role
 *
 * Lifecycle endpoints for the acting tenant's roles.
 */
export const tenancyRolesDestroy = <ThrowOnError extends boolean = false>(
  options: Options<TenancyRolesDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<TenancyRolesDestroyResponses, TenancyRolesDestroyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenancy/roles/{role_id}/',
    ...options,
  })

/**
 * Get a role
 *
 * Lifecycle endpoints for the acting tenant's roles.
 */
export const tenancyRolesRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<TenancyRolesRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<TenancyRolesRetrieveResponses, TenancyRolesRetrieveErrors, ThrowOnError>({
    responseTransformer: tenancyRolesRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenancy/roles/{role_id}/',
    ...options,
  })

/**
 * Partially update a role
 *
 * Lifecycle endpoints for the acting tenant's roles.
 */
export const tenancyRolesPartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<TenancyRolesPartialUpdateData, ThrowOnError>
) =>
  (options.client ?? client).patch<TenancyRolesPartialUpdateResponses, TenancyRolesPartialUpdateErrors, ThrowOnError>({
    responseTransformer: tenancyRolesPartialUpdateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenancy/roles/{role_id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Update a role
 *
 * Lifecycle endpoints for the acting tenant's roles.
 */
export const tenancyRolesUpdate = <ThrowOnError extends boolean = false>(
  options: Options<TenancyRolesUpdateData, ThrowOnError>
) =>
  (options.client ?? client).put<TenancyRolesUpdateResponses, TenancyRolesUpdateErrors, ThrowOnError>({
    responseTransformer: tenancyRolesUpdateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenancy/roles/{role_id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Search roles
 *
 * Lists the acting tenant's roles oldest first. The tenant is taken from the `X-Acting-Tenant` header, so another tenant's roles are never returned. Filters travel in the request body; pagination uses the `cursor` and `page_size` query parameters.
 */
export const tenancyRolesSearchCreate = <ThrowOnError extends boolean = false>(
  options: Options<TenancyRolesSearchCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<TenancyRolesSearchCreateResponses, TenancyRolesSearchCreateErrors, ThrowOnError>({
    responseTransformer: tenancyRolesSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenancy/roles/search/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Create a tenant
 */
export const tenancyTenantsCreate = <ThrowOnError extends boolean = false>(
  options: Options<TenancyTenantsCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<TenancyTenantsCreateResponses, unknown, ThrowOnError>({
    responseTransformer: tenancyTenantsCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenancy/tenants/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Delete a tenant
 *
 * Deletes a tenant. A tenant that still has users cannot be deleted and returns 409.
 */
export const tenancyTenantsDestroy = <ThrowOnError extends boolean = false>(
  options: Options<TenancyTenantsDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<TenancyTenantsDestroyResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenancy/tenants/{tenant_id}/',
    ...options,
  })

/**
 * Get a tenant
 */
export const tenancyTenantsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<TenancyTenantsRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<TenancyTenantsRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: tenancyTenantsRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenancy/tenants/{tenant_id}/',
    ...options,
  })

/**
 * Update a tenant
 */
export const tenancyTenantsUpdate = <ThrowOnError extends boolean = false>(
  options: Options<TenancyTenantsUpdateData, ThrowOnError>
) =>
  (options.client ?? client).put<TenancyTenantsUpdateResponses, unknown, ThrowOnError>({
    responseTransformer: tenancyTenantsUpdateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenancy/tenants/{tenant_id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Search tenants
 *
 * Lists tenants oldest first. Filters travel in the request body; pagination uses the `cursor` and `page_size` query parameters.
 */
export const tenancyTenantsSearchCreate = <ThrowOnError extends boolean = false>(
  options?: Options<TenancyTenantsSearchCreateData, ThrowOnError>
) =>
  (options?.client ?? client).post<TenancyTenantsSearchCreateResponses, unknown, ThrowOnError>({
    responseTransformer: tenancyTenantsSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenancy/tenants/search/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Create a user
 *
 * Creates a user. A user that duplicates another user's identity in the same tenant returns 409.
 */
export const tenancyUsersCreate = <ThrowOnError extends boolean = false>(
  options: Options<TenancyUsersCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<TenancyUsersCreateResponses, unknown, ThrowOnError>({
    responseTransformer: tenancyUsersCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenancy/users/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Delete a user
 */
export const tenancyUsersDestroy = <ThrowOnError extends boolean = false>(
  options: Options<TenancyUsersDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<TenancyUsersDestroyResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenancy/users/{user_id}/',
    ...options,
  })

/**
 * Get a user
 */
export const tenancyUsersRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<TenancyUsersRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<TenancyUsersRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: tenancyUsersRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenancy/users/{user_id}/',
    ...options,
  })

/**
 * Update a user
 */
export const tenancyUsersUpdate = <ThrowOnError extends boolean = false>(
  options: Options<TenancyUsersUpdateData, ThrowOnError>
) =>
  (options.client ?? client).put<TenancyUsersUpdateResponses, unknown, ThrowOnError>({
    responseTransformer: tenancyUsersUpdateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenancy/users/{user_id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Search users
 *
 * Lists users oldest first. Filters travel in the request body; pagination uses the `cursor` and `page_size` query parameters.
 */
export const tenancyUsersSearchCreate = <ThrowOnError extends boolean = false>(
  options?: Options<TenancyUsersSearchCreateData, ThrowOnError>
) =>
  (options?.client ?? client).post<TenancyUsersSearchCreateResponses, unknown, ThrowOnError>({
    responseTransformer: tenancyUsersSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenancy/users/search/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Search audit events
 *
 * Search audit events with filters supplied in the request body. Filters that may contain large, unbounded collections (e.g. audit_event_names) are sent in the body to avoid overflowing URL-length limits. Pagination uses the `cursor` and `page_size` query parameters.
 */
export const transparencyAuditEventsSearchCreate = <ThrowOnError extends boolean = false>(
  options?: Options<TransparencyAuditEventsSearchCreateData, ThrowOnError>
) =>
  (options?.client ?? client).post<TransparencyAuditEventsSearchCreateResponses, unknown, ThrowOnError>({
    responseTransformer: transparencyAuditEventsSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/audit-events/search/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Create an external meeting ID
 */
export const transparencyExternalMeetingIdsCreate = <ThrowOnError extends boolean = false>(
  options: Options<TransparencyExternalMeetingIdsCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<TransparencyExternalMeetingIdsCreateResponses, unknown, ThrowOnError>({
    responseTransformer: transparencyExternalMeetingIdsCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/external-meeting-ids/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Delete an external meeting ID
 */
export const transparencyExternalMeetingIdsDestroy = <ThrowOnError extends boolean = false>(
  options: Options<TransparencyExternalMeetingIdsDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<TransparencyExternalMeetingIdsDestroyResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/external-meeting-ids/{id}/',
    ...options,
  })

/**
 * Create a general meeting
 */
export const transparencyGeneralMeetingsCreate = <ThrowOnError extends boolean = false>(
  options: Options<TransparencyGeneralMeetingsCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<TransparencyGeneralMeetingsCreateResponses, unknown, ThrowOnError>({
    responseTransformer: transparencyGeneralMeetingsCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/general-meetings/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Get a general meeting by ID
 */
export const transparencyGeneralMeetingsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<TransparencyGeneralMeetingsRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<TransparencyGeneralMeetingsRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: transparencyGeneralMeetingsRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/general-meetings/{id}/',
    ...options,
  })

/**
 * Update a general meeting (partial update)
 */
export const transparencyGeneralMeetingsPartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<TransparencyGeneralMeetingsPartialUpdateData, ThrowOnError>
) =>
  (options.client ?? client).patch<TransparencyGeneralMeetingsPartialUpdateResponses, unknown, ThrowOnError>({
    responseTransformer: transparencyGeneralMeetingsPartialUpdateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/general-meetings/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Search general meetings
 *
 * Search general meetings with filters supplied in the request body. Filters that may contain large, unbounded collections (e.g. general_meeting_names) are sent in the body to avoid overflowing URL-length limits. Pagination uses the `cursor` and `page_size` query parameters.
 */
export const transparencyGeneralMeetingsSearchCreate = <ThrowOnError extends boolean = false>(
  options?: Options<TransparencyGeneralMeetingsSearchCreateData, ThrowOnError>
) =>
  (options?.client ?? client).post<TransparencyGeneralMeetingsSearchCreateResponses, unknown, ThrowOnError>({
    responseTransformer: transparencyGeneralMeetingsSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/general-meetings/search/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Create an instrument
 *
 * Creates an instrument, validated as defined by the instrument resource.
 */
export const transparencyInstrumentsCreate = <ThrowOnError extends boolean = false>(
  options: Options<TransparencyInstrumentsCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<TransparencyInstrumentsCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/instruments/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Delete an instrument
 *
 * Deletes the instrument.
 */
export const transparencyInstrumentsDestroy = <ThrowOnError extends boolean = false>(
  options: Options<TransparencyInstrumentsDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<TransparencyInstrumentsDestroyResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/instruments/{isin}/',
    ...options,
  })

/**
 * Get an instrument by ISIN
 *
 * Returns an instrument by its identifier, the ISIN.
 */
export const transparencyInstrumentsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<TransparencyInstrumentsRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<TransparencyInstrumentsRetrieveResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/instruments/{isin}/',
    ...options,
  })

/**
 * Replace an instrument
 *
 * Replaces every field on the instrument.
 */
export const transparencyInstrumentsUpdate = <ThrowOnError extends boolean = false>(
  options: Options<TransparencyInstrumentsUpdateData, ThrowOnError>
) =>
  (options.client ?? client).put<TransparencyInstrumentsUpdateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/instruments/{isin}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Fetch the minimal projection of many instruments at once
 *
 * Fetches instruments given a list of ISINs. Designed to be more performant than the list endpoint when only a subset of fields is needed.
 */
export const transparencyInstrumentsFetchMinimalCreate = <ThrowOnError extends boolean = false>(
  options: Options<TransparencyInstrumentsFetchMinimalCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<TransparencyInstrumentsFetchMinimalCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/instruments/fetch-minimal/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Search instruments
 *
 * Search instruments with filters supplied in the request body. Filters that may contain large, unbounded collections (e.g. isins, public_security_id_names) are sent in the body to avoid overflowing URL-length limits. Pagination uses the `cursor` and `page_size` query parameters.
 */
export const transparencyInstrumentsSearchCreate = <ThrowOnError extends boolean = false>(
  options?: Options<TransparencyInstrumentsSearchCreateData, ThrowOnError>
) =>
  (options?.client ?? client).post<TransparencyInstrumentsSearchCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/instruments/search/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * List non-composite instruments not linked to any organization
 *
 * Returns the non-composite instruments which do not have an association to an organization.
 */
export const transparencyInstrumentsUnassociatedRetrieve = <ThrowOnError extends boolean = false>(
  options?: Options<TransparencyInstrumentsUnassociatedRetrieveData, ThrowOnError>
) =>
  (options?.client ?? client).get<TransparencyInstrumentsUnassociatedRetrieveResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/instruments/unassociated/',
    ...options,
  })

/**
 * Create an organization
 */
export const transparencyOrganizationsCreate = <ThrowOnError extends boolean = false>(
  options: Options<TransparencyOrganizationsCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<TransparencyOrganizationsCreateResponses, unknown, ThrowOnError>({
    responseTransformer: transparencyOrganizationsCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/organizations/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Delete an organization
 */
export const transparencyOrganizationsDestroy = <ThrowOnError extends boolean = false>(
  options: Options<TransparencyOrganizationsDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<TransparencyOrganizationsDestroyResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/organizations/{id}/',
    ...options,
  })

/**
 * Get an organization by ID
 */
export const transparencyOrganizationsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<TransparencyOrganizationsRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<TransparencyOrganizationsRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: transparencyOrganizationsRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/organizations/{id}/',
    ...options,
  })

/**
 * Patch an organization (partial update)
 */
export const transparencyOrganizationsPartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<TransparencyOrganizationsPartialUpdateData, ThrowOnError>
) =>
  (options.client ?? client).patch<TransparencyOrganizationsPartialUpdateResponses, unknown, ThrowOnError>({
    responseTransformer: transparencyOrganizationsPartialUpdateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/organizations/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Replace an organization (full update)
 */
export const transparencyOrganizationsUpdate = <ThrowOnError extends boolean = false>(
  options: Options<TransparencyOrganizationsUpdateData, ThrowOnError>
) =>
  (options.client ?? client).put<TransparencyOrganizationsUpdateResponses, unknown, ThrowOnError>({
    responseTransformer: transparencyOrganizationsUpdateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/organizations/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Upload a new logo for an organization
 */
export const transparencyOrganizationsLogoCreate = <ThrowOnError extends boolean = false>(
  options: Options<TransparencyOrganizationsLogoCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<TransparencyOrganizationsLogoCreateResponses, unknown, ThrowOnError>({
    responseTransformer: transparencyOrganizationsLogoCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/organizations/{id}/logo/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Create a proposal
 */
export const transparencyOrganizationsGeneralMeetingsProposalsCreate = <ThrowOnError extends boolean = false>(
  options: Options<TransparencyOrganizationsGeneralMeetingsProposalsCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    TransparencyOrganizationsGeneralMeetingsProposalsCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseTransformer: transparencyOrganizationsGeneralMeetingsProposalsCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/organizations/{org_id}/general-meetings/{gm_id}/proposals/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Get a proposal by ID
 */
export const transparencyOrganizationsGeneralMeetingsProposalsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<TransparencyOrganizationsGeneralMeetingsProposalsRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TransparencyOrganizationsGeneralMeetingsProposalsRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseTransformer: transparencyOrganizationsGeneralMeetingsProposalsRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/organizations/{org_id}/general-meetings/{gm_id}/proposals/{proposal_id}/',
    ...options,
  })

/**
 * Partially update a proposal (merges over the current version)
 *
 * Updates only the fields supplied in the request, preserving all others from the proposal's current version. Creates a new version, invalidating the previous one.
 */
export const transparencyOrganizationsGeneralMeetingsProposalsPartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<TransparencyOrganizationsGeneralMeetingsProposalsPartialUpdateData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    TransparencyOrganizationsGeneralMeetingsProposalsPartialUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseTransformer: transparencyOrganizationsGeneralMeetingsProposalsPartialUpdateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/organizations/{org_id}/general-meetings/{gm_id}/proposals/{proposal_id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Update a proposal (full replace of current version)
 */
export const transparencyOrganizationsGeneralMeetingsProposalsUpdate = <ThrowOnError extends boolean = false>(
  options: Options<TransparencyOrganizationsGeneralMeetingsProposalsUpdateData, ThrowOnError>
) =>
  (options.client ?? client).put<
    TransparencyOrganizationsGeneralMeetingsProposalsUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseTransformer: transparencyOrganizationsGeneralMeetingsProposalsUpdateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/organizations/{org_id}/general-meetings/{gm_id}/proposals/{proposal_id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Search proposals within a general meeting
 *
 * Search proposals with filters supplied in the request body. Pagination uses the `cursor` and `page_size` query parameters.
 */
export const transparencyOrganizationsGeneralMeetingsProposalsSearchCreate = <ThrowOnError extends boolean = false>(
  options: Options<TransparencyOrganizationsGeneralMeetingsProposalsSearchCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    TransparencyOrganizationsGeneralMeetingsProposalsSearchCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseTransformer: transparencyOrganizationsGeneralMeetingsProposalsSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/organizations/{org_id}/general-meetings/{gm_id}/proposals/search/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Look up an organization by external identifier
 */
export const transparencyOrganizationsGetByIdentifierCreate = <ThrowOnError extends boolean = false>(
  options: Options<TransparencyOrganizationsGetByIdentifierCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<TransparencyOrganizationsGetByIdentifierCreateResponses, unknown, ThrowOnError>({
    responseTransformer: transparencyOrganizationsGetByIdentifierCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/organizations/get-by-identifier/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Resolve a batch of ISINs to organization names
 */
export const transparencyOrganizationsIsinsToNamesCreate = <ThrowOnError extends boolean = false>(
  options: Options<TransparencyOrganizationsIsinsToNamesCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<TransparencyOrganizationsIsinsToNamesCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/organizations/isins-to-names/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Search organizations
 *
 * Search organizations with filters supplied in the request body. Filters that may contain large, unbounded collections (e.g. names) are sent in the body to avoid overflowing URL-length limits. Pagination uses the `cursor` and `page_size` query parameters.
 */
export const transparencyOrganizationsSearchCreate = <ThrowOnError extends boolean = false>(
  options?: Options<TransparencyOrganizationsSearchCreateData, ThrowOnError>
) =>
  (options?.client ?? client).post<TransparencyOrganizationsSearchCreateResponses, unknown, ThrowOnError>({
    responseTransformer: transparencyOrganizationsSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/organizations/search/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * List proposal classification codes
 */
export const transparencyProposalsClassificationCodesRetrieve = <ThrowOnError extends boolean = false>(
  options?: Options<TransparencyProposalsClassificationCodesRetrieveData, ThrowOnError>
) =>
  (options?.client ?? client).get<TransparencyProposalsClassificationCodesRetrieveResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/proposals/classification-codes/',
    ...options,
  })

/**
 * Count proposals per general meeting
 */
export const transparencyProposalsCountCreate = <ThrowOnError extends boolean = false>(
  options: Options<TransparencyProposalsCountCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<TransparencyProposalsCountCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/proposals/count/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Fetch proposals across multiple general meetings
 *
 * Fetch proposals across multiple general meetings with optional votability filters. Pagination uses the `cursor` and `page_size` query parameters.
 */
export const transparencyProposalsFetchCreate = <ThrowOnError extends boolean = false>(
  options: Options<TransparencyProposalsFetchCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<TransparencyProposalsFetchCreateResponses, unknown, ThrowOnError>({
    responseTransformer: transparencyProposalsFetchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/proposals/fetch/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Fetch proposal resource names from identity UUIDs
 */
export const transparencyProposalsFetchNamesFromIdsCreate = <ThrowOnError extends boolean = false>(
  options: Options<TransparencyProposalsFetchNamesFromIdsCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<TransparencyProposalsFetchNamesFromIdsCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/proposals/fetch-names-from-ids/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * List SEC proposal category codes
 */
export const transparencyProposalsSecClassificationCodesRetrieve = <ThrowOnError extends boolean = false>(
  options?: Options<TransparencyProposalsSecClassificationCodesRetrieveData, ThrowOnError>
) =>
  (options?.client ?? client).get<TransparencyProposalsSecClassificationCodesRetrieveResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/proposals/sec-classification-codes/',
    ...options,
  })

/**
 * Search public security IDs
 *
 * Search public security IDs with filters supplied in the request body. Filters that may contain large, unbounded collections (e.g. names, values) are sent in the body to avoid overflowing URL-length limits. Pagination uses the `cursor` and `page_size` query parameters.
 */
export const transparencyPublicSecurityIdsSearchCreate = <ThrowOnError extends boolean = false>(
  options?: Options<TransparencyPublicSecurityIdsSearchCreateData, ThrowOnError>
) =>
  (options?.client ?? client).post<TransparencyPublicSecurityIdsSearchCreateResponses, unknown, ThrowOnError>({
    responseTransformer: transparencyPublicSecurityIdsSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/public-security-ids/search/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Filter proxy intermediary ballot search results with cursor-based pagination.
 */
export const votingOperationsPiballotsFilterList = <ThrowOnError extends boolean = false>(
  options?: Options<VotingOperationsPiballotsFilterListData, ThrowOnError>
) =>
  (options?.client ?? client).get<VotingOperationsPiballotsFilterListResponses, unknown, ThrowOnError>({
    responseTransformer: votingOperationsPiballotsFilterListResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-operations/piballots/filter',
    ...options,
  })

/**
 * Filter proxy intermediary meeting search results with cursor-based pagination. Returns meetings that are in scope for voting operations workflow, along with their scope information.
 */
export const votingOperationsPimeetingsFilterList = <ThrowOnError extends boolean = false>(
  options?: Options<VotingOperationsPimeetingsFilterListData, ThrowOnError>
) =>
  (options?.client ?? client).get<VotingOperationsPimeetingsFilterListResponses, unknown, ThrowOnError>({
    responseTransformer: votingOperationsPimeetingsFilterListResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-operations/pimeetings/filter',
    ...options,
  })

/**
 * Get proposal set recommendation coverage detail
 *
 * Composes everything the recommendation coverage detail of one proposal set under one voting policy needs: every proposal in the set with its current proxy intermediary voting recommendation (and the provider voting recommendation it was matched from), plus the provider voting recommendations of the latest batch for the meeting and policy that remain unmatched. The batch is identified through a matched recommendation's PVR link; when no recommendation links a PVR, the batch fields are null and no unmatched recommendations are returned.
 */
export const votingPolicyProposalSetRecommendationCoverageDetailRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<VotingPolicyProposalSetRecommendationCoverageDetailRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<
    VotingPolicyProposalSetRecommendationCoverageDetailRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseTransformer: votingPolicyProposalSetRecommendationCoverageDetailRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-policy/proposal-set-recommendation-coverage/detail/',
    ...options,
  })

/**
 * Search proposal set recommendation coverage
 *
 * Reports, for each proxy intermediary meeting, proposal set and voting policy, how far voting recommendation matching has progressed and the window of vote deadlines its ballots fall in. A row is returned while at least one of its ballots is still votable and the working day its earliest deadline effectively falls on is within the `due_in` window, so a proposal set stays listed for its remaining ballots after the earliest one has passed. Filters are supplied in the request body; pagination uses the `cursor` and `page_size` query parameters. Results are ordered by earliest vote deadline, soonest first. Supply `validation_statuses` to return only the rows whose recommendations are all checked, or only those with review outstanding.
 */
export const votingPolicyProposalSetRecommendationCoverageSearchCreate = <ThrowOnError extends boolean = false>(
  options?: Options<VotingPolicyProposalSetRecommendationCoverageSearchCreateData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    VotingPolicyProposalSetRecommendationCoverageSearchCreateResponses,
    VotingPolicyProposalSetRecommendationCoverageSearchCreateErrors,
    ThrowOnError
  >({
    responseTransformer: votingPolicyProposalSetRecommendationCoverageSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-policy/proposal-set-recommendation-coverage/search/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Create a provider voting recommendation
 *
 * Creates a provider voting recommendation. Validates that the parent voting policy exists. Returns 409 Conflict if an identical recommendation already exists.
 */
export const votingPolicyProviderVotingRecommendationsCreate = <ThrowOnError extends boolean = false>(
  options: Options<VotingPolicyProviderVotingRecommendationsCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<VotingPolicyProviderVotingRecommendationsCreateResponses, unknown, ThrowOnError>({
    responseTransformer: votingPolicyProviderVotingRecommendationsCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-policy/provider-voting-recommendations/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Delete a provider voting recommendation
 *
 * Soft-deletes a provider voting recommendation by setting its delete_time.
 */
export const votingPolicyProviderVotingRecommendationsDestroy = <ThrowOnError extends boolean = false>(
  options: Options<VotingPolicyProviderVotingRecommendationsDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<VotingPolicyProviderVotingRecommendationsDestroyResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-policy/provider-voting-recommendations/{id}/',
    ...options,
  })

/**
 * Match a provider voting recommendation to a proposal
 *
 * Creates a voting recommendation for a proposal from this provider voting recommendation (PVR), copying the PVR's instruction, rationale, proposal text/label/sequence number and id. The parent voting policy is taken from the PVR. Validates that the proposal exists, the instruction is valid for it, and the proxy intermediary deadline has not passed. Returns 409 Conflict if an active recommendation already exists for the policy and proposal; a soft-deleted recommendation is revived instead. If the PVR carries an external_meeting_id, a best-effort external meeting id mapping is created.
 */
export const votingPolicyProviderVotingRecommendationsMatchCreate = <ThrowOnError extends boolean = false>(
  options: Options<VotingPolicyProviderVotingRecommendationsMatchCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<VotingPolicyProviderVotingRecommendationsMatchCreateResponses, unknown, ThrowOnError>(
    {
      responseTransformer: votingPolicyProviderVotingRecommendationsMatchCreateResponseTransformer,
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/voting-policy/provider-voting-recommendations/{id}/match/',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    }
  )

/**
 * Fetch provider voting recommendations by version
 *
 * Returns all non-deleted provider voting recommendations for a specific meeting+policy batch version, identified by unique_meeting_policy_id and meeting_batch_version. The result is not paginated.
 */
export const votingPolicyProviderVotingRecommendationsFetchByVersionRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<VotingPolicyProviderVotingRecommendationsFetchByVersionRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<
    VotingPolicyProviderVotingRecommendationsFetchByVersionRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseTransformer: votingPolicyProviderVotingRecommendationsFetchByVersionRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-policy/provider-voting-recommendations/fetch-by-version/',
    ...options,
  })

/**
 * Search provider voting recommendations
 *
 * Searches provider voting recommendations with filters supplied in the request body. Filters that may contain large, unbounded collections (e.g. isins, policy_ids) are sent in the body to avoid overflowing URL-length limits. Soft-deleted recommendations are always excluded. The `meeting_date` filter matches a single calendar day and cannot be combined with the inclusive `meeting_date_after` / `meeting_date_before` range bounds. Pagination uses the `cursor` and `page_size` query parameters.
 */
export const votingPolicyProviderVotingRecommendationsSearchCreate = <ThrowOnError extends boolean = false>(
  options?: Options<VotingPolicyProviderVotingRecommendationsSearchCreateData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    VotingPolicyProviderVotingRecommendationsSearchCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseTransformer: votingPolicyProviderVotingRecommendationsSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-policy/provider-voting-recommendations/search/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Upsert a proxy intermediary voting recommendation confidence score
 *
 * Creates or replaces the validation confidence score for the given algorithm against a proxy intermediary voting recommendation version. The confidence score must be between 0.0 and 1.0. Returns 201 when a new score is created and 200 when an existing score (same version and algorithm) is updated.
 */
export const votingPolicyProxyIntermediaryVotingRecommendationConfidenceScoresUpdate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<VotingPolicyProxyIntermediaryVotingRecommendationConfidenceScoresUpdateData, ThrowOnError>
) =>
  (options.client ?? client).put<
    VotingPolicyProxyIntermediaryVotingRecommendationConfidenceScoresUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseTransformer: votingPolicyProxyIntermediaryVotingRecommendationConfidenceScoresUpdateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-policy/proxy-intermediary-voting-recommendation-confidence-scores/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Create a proxy intermediary voting recommendation validation status
 *
 * Records a validation status against a proxy intermediary voting recommendation version. Statuses are append-only: recording a status never replaces an earlier one, and the current status of a version is its most recently created one. The status is attributed to the authenticated caller.
 */
export const votingPolicyProxyIntermediaryVotingRecommendationValidationStatusesCreate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<VotingPolicyProxyIntermediaryVotingRecommendationValidationStatusesCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    VotingPolicyProxyIntermediaryVotingRecommendationValidationStatusesCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseTransformer: votingPolicyProxyIntermediaryVotingRecommendationValidationStatusesCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-policy/proxy-intermediary-voting-recommendation-validation-statuses/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Search proxy intermediary voting recommendation validation statuses
 *
 * Returns validation statuses matching the body filters, newest first. By default only the current status of each recommendation is returned; set include_history to return every status ever recorded. Filters are optional and combine with AND; the recommendation ids are taken from the body rather than the query string so a large set does not overflow URL-length limits.
 */
export const votingPolicyProxyIntermediaryVotingRecommendationValidationStatusesSearchCreate = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<VotingPolicyProxyIntermediaryVotingRecommendationValidationStatusesSearchCreateData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    VotingPolicyProxyIntermediaryVotingRecommendationValidationStatusesSearchCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseTransformer:
      votingPolicyProxyIntermediaryVotingRecommendationValidationStatusesSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-policy/proxy-intermediary-voting-recommendation-validation-statuses/search/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Create a proxy intermediary voting recommendation
 *
 * Creates a proxy intermediary voting recommendation for a proposal under the given voting policy. Validates that the voting policy and proposal exist, the voting instruction is not no_action and is valid for the proposal, and the proxy intermediary submission deadline has not passed. Returns 409 Conflict if a live recommendation already exists for the policy and proposal.
 */
export const votingPolicyProxyIntermediaryVotingRecommendationsCreate = <ThrowOnError extends boolean = false>(
  options: Options<VotingPolicyProxyIntermediaryVotingRecommendationsCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    VotingPolicyProxyIntermediaryVotingRecommendationsCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseTransformer: votingPolicyProxyIntermediaryVotingRecommendationsCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-policy/proxy-intermediary-voting-recommendations/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Delete a proxy intermediary voting recommendation
 *
 * Soft-deletes the recommendation by closing its current version: sets delete_time (and deleted_by_sub) on the version row. The identity and all version history are retained. Returns 404 if the recommendation does not exist or is already deleted.
 */
export const votingPolicyProxyIntermediaryVotingRecommendationsDestroy = <ThrowOnError extends boolean = false>(
  options: Options<VotingPolicyProxyIntermediaryVotingRecommendationsDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    VotingPolicyProxyIntermediaryVotingRecommendationsDestroyResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-policy/proxy-intermediary-voting-recommendations/{identity_id}/',
    ...options,
  })

/**
 * Match a proxy intermediary proposal to a provider voting recommendation
 *
 * Creates a proxy intermediary voting recommendation from a provider voting recommendation (PVR), copying the PVR's voting policy, instruction, rationale and proposal text/label/sequence number. The proxy intermediary proposal is the join target and supplies validation only. Validates that the PVR and proposal exist, the PVR's instruction is valid for the proposal, and the proxy intermediary submission deadline has not passed. Matching a proposal that is already live under the same voting policy supersedes it with a new version carrying the new PVR's values.
 */
export const votingPolicyProxyIntermediaryVotingRecommendationsMatchFromPvrCreate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<VotingPolicyProxyIntermediaryVotingRecommendationsMatchFromPvrCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    VotingPolicyProxyIntermediaryVotingRecommendationsMatchFromPvrCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseTransformer: votingPolicyProxyIntermediaryVotingRecommendationsMatchFromPvrCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-policy/proxy-intermediary-voting-recommendations/match-from-pvr/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Search proxy intermediary voting recommendations
 *
 * Searches the current proxy intermediary voting recommendations with filters supplied in the request body. Filters that may contain large, unbounded collections (proposal, provider voting recommendation and voting policy id lists) are sent in the body to avoid overflowing URL-length limits. All filters are optional and combine with AND. Results are cursor-paginated.
 */
export const votingPolicyProxyIntermediaryVotingRecommendationsSearchCreate = <ThrowOnError extends boolean = false>(
  options?: Options<VotingPolicyProxyIntermediaryVotingRecommendationsSearchCreateData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    VotingPolicyProxyIntermediaryVotingRecommendationsSearchCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseTransformer: votingPolicyProxyIntermediaryVotingRecommendationsSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-policy/proxy-intermediary-voting-recommendations/search/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Get a proxy intermediary voting recommendation version
 *
 * Returns the version addressed by id exactly as recorded, whether it is the current version, a superseded one, or one closed by deletion. delete_time is null while the version is current.
 */
export const votingPolicyProxyIntermediaryVotingRecommendationsVersionsRetrieve = <
  ThrowOnError extends boolean = false,
>(
  options: Options<VotingPolicyProxyIntermediaryVotingRecommendationsVersionsRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<
    VotingPolicyProxyIntermediaryVotingRecommendationsVersionsRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseTransformer: votingPolicyProxyIntermediaryVotingRecommendationsVersionsRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-policy/proxy-intermediary-voting-recommendations/versions/{id}/',
    ...options,
  })

/**
 * Create a voting policy
 *
 * Creates a voting policy. The id is server-generated. `available_to_investor_type` must contain at least one investor type. If supplied, `image_url` must be a Cloudinary URL.
 */
export const votingPolicyVotingPoliciesCreate = <ThrowOnError extends boolean = false>(
  options: Options<VotingPolicyVotingPoliciesCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<VotingPolicyVotingPoliciesCreateResponses, unknown, ThrowOnError>({
    responseTransformer: votingPolicyVotingPoliciesCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-policy/voting-policies/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Delete a voting policy
 *
 * Deletes a voting policy and cascades deletion of its policy documents (DB + S3). Returns 409 Conflict if any voting recommendations exist for the policy.
 */
export const votingPolicyVotingPoliciesDestroy = <ThrowOnError extends boolean = false>(
  options: Options<VotingPolicyVotingPoliciesDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<VotingPolicyVotingPoliciesDestroyResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-policy/voting-policies/{id}/',
    ...options,
  })

/**
 * Get a voting policy
 *
 * Returns a single voting policy by its UUID, with the most recent voting policy document attached as `current_policy_document` (null if the policy has no documents).
 */
export const votingPolicyVotingPoliciesRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<VotingPolicyVotingPoliciesRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<VotingPolicyVotingPoliciesRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: votingPolicyVotingPoliciesRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-policy/voting-policies/{id}/',
    ...options,
  })

/**
 * Update a voting policy
 *
 * Partially updates a voting policy. Only fields present in the request body are updated; absent fields are left untouched.
 */
export const votingPolicyVotingPoliciesPartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<VotingPolicyVotingPoliciesPartialUpdateData, ThrowOnError>
) =>
  (options.client ?? client).patch<VotingPolicyVotingPoliciesPartialUpdateResponses, unknown, ThrowOnError>({
    responseTransformer: votingPolicyVotingPoliciesPartialUpdateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-policy/voting-policies/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * List voting policy documents
 *
 * Returns voting policy documents for a given voting policy, ordered by issue time descending. Supports pagination.
 */
export const votingPolicyVotingPoliciesDocumentsList = <ThrowOnError extends boolean = false>(
  options: Options<VotingPolicyVotingPoliciesDocumentsListData, ThrowOnError>
) =>
  (options.client ?? client).get<VotingPolicyVotingPoliciesDocumentsListResponses, unknown, ThrowOnError>({
    responseTransformer: votingPolicyVotingPoliciesDocumentsListResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-policy/voting-policies/{voting_policy_id}/documents/',
    ...options,
  })

/**
 * Create a voting policy document
 *
 * Uploads a PDF and creates a document record for a voting policy. The request body must be the raw PDF file with Content-Type: application/pdf. The file must not exceed 10 MB. The issue_time must not be in the future.
 */
export const votingPolicyVotingPoliciesDocumentsCreate = <ThrowOnError extends boolean = false>(
  options: Options<VotingPolicyVotingPoliciesDocumentsCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<VotingPolicyVotingPoliciesDocumentsCreateResponses, unknown, ThrowOnError>({
    bodySerializer: null,
    responseTransformer: votingPolicyVotingPoliciesDocumentsCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-policy/voting-policies/{voting_policy_id}/documents/',
    ...options,
    headers: {
      'Content-Type': 'application/pdf',
      ...options.headers,
    },
  })

/**
 * Get a voting policy document
 *
 * Returns a single voting policy document by its integer ID.
 */
export const votingPolicyVotingPoliciesDocumentsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<VotingPolicyVotingPoliciesDocumentsRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<VotingPolicyVotingPoliciesDocumentsRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: votingPolicyVotingPoliciesDocumentsRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-policy/voting-policies/{voting_policy_id}/documents/{id}/',
    ...options,
  })

/**
 * Update a voting policy document
 *
 * Partially updates a voting policy document. Only title and issue_time may be changed.
 */
export const votingPolicyVotingPoliciesDocumentsPartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<VotingPolicyVotingPoliciesDocumentsPartialUpdateData, ThrowOnError>
) =>
  (options.client ?? client).patch<VotingPolicyVotingPoliciesDocumentsPartialUpdateResponses, unknown, ThrowOnError>({
    responseTransformer: votingPolicyVotingPoliciesDocumentsPartialUpdateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-policy/voting-policies/{voting_policy_id}/documents/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Create a voting recommendation
 *
 * Creates a voting recommendation for a proposal under the given voting policy. Validates that the proposal exists, the voting instruction is valid for that proposal, and the proxy intermediary deadline has not passed. Returns 409 Conflict if an active recommendation already exists for the policy and proposal; a soft-deleted recommendation is revived instead.
 */
export const votingPolicyVotingPoliciesVotingRecommendationsCreate = <ThrowOnError extends boolean = false>(
  options: Options<VotingPolicyVotingPoliciesVotingRecommendationsCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    VotingPolicyVotingPoliciesVotingRecommendationsCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseTransformer: votingPolicyVotingPoliciesVotingRecommendationsCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-policy/voting-policies/{voting_policy_id}/voting-recommendations/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Delete a voting recommendation
 *
 * Soft-deletes a voting recommendation.
 */
export const votingPolicyVotingPoliciesVotingRecommendationsDestroy = <ThrowOnError extends boolean = false>(
  options: Options<VotingPolicyVotingPoliciesVotingRecommendationsDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    VotingPolicyVotingPoliciesVotingRecommendationsDestroyResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-policy/voting-policies/{voting_policy_id}/voting-recommendations/{id}/',
    ...options,
  })

/**
 * Get a voting recommendation
 *
 * Returns a single voting recommendation by its version ID.
 */
export const votingPolicyVotingPoliciesVotingRecommendationsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<VotingPolicyVotingPoliciesVotingRecommendationsRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<
    VotingPolicyVotingPoliciesVotingRecommendationsRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseTransformer: votingPolicyVotingPoliciesVotingRecommendationsRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-policy/voting-policies/{voting_policy_id}/voting-recommendations/{id}/',
    ...options,
  })

/**
 * Update a voting recommendation
 *
 * Updates a voting recommendation's voting_instruction and/or rationale. Creates a new version of the recommendation, invalidating the previous one. Re-validates the voting instruction and proxy deadline on each update. Returns 409 Conflict if no fields change, leaving the current version active.
 */
export const votingPolicyVotingPoliciesVotingRecommendationsPartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<VotingPolicyVotingPoliciesVotingRecommendationsPartialUpdateData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    VotingPolicyVotingPoliciesVotingRecommendationsPartialUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseTransformer: votingPolicyVotingPoliciesVotingRecommendationsPartialUpdateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-policy/voting-policies/{voting_policy_id}/voting-recommendations/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Update a voting recommendation from a provider voting recommendation
 *
 * Updates an existing voting recommendation from a provider voting recommendation (PVR), creating a new version. Copies the PVR's voting_instruction, rationale, proposal_sequence_number and id onto the new version; proposal_name, proposal_text and proposal_label are preserved. Re-validates the voting instruction and proxy deadline. Returns 404 if the voting recommendation or the PVR does not exist.
 */
export const votingPolicyVotingPoliciesVotingRecommendationsUpdateFromPvrCreate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<VotingPolicyVotingPoliciesVotingRecommendationsUpdateFromPvrCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    VotingPolicyVotingPoliciesVotingRecommendationsUpdateFromPvrCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseTransformer: votingPolicyVotingPoliciesVotingRecommendationsUpdateFromPvrCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-policy/voting-policies/{voting_policy_id}/voting-recommendations/{id}/update-from-pvr/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Search voting recommendations
 *
 * Searches the current voting recommendations for a voting policy, one per proposal, with filters supplied in the request body. Filters that may contain large, unbounded collections (e.g. proposal_names) are sent in the body to avoid overflowing URL-length limits. Results are cursor-paginated.
 */
export const votingPolicyVotingPoliciesVotingRecommendationsSearchCreate = <ThrowOnError extends boolean = false>(
  options: Options<VotingPolicyVotingPoliciesVotingRecommendationsSearchCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    VotingPolicyVotingPoliciesVotingRecommendationsSearchCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseTransformer: votingPolicyVotingPoliciesVotingRecommendationsSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-policy/voting-policies/{voting_policy_id}/voting-recommendations/search/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Search voting policies
 *
 * Searches voting policies with filters supplied in the request body. Filters that may contain large, unbounded collections (e.g. voting_policy_ids) are sent in the body to avoid overflowing URL-length limits. Results include the most recent voting policy document per policy (null if none exist).
 */
export const votingPolicyVotingPoliciesSearchCreate = <ThrowOnError extends boolean = false>(
  options?: Options<VotingPolicyVotingPoliciesSearchCreateData, ThrowOnError>
) =>
  (options?.client ?? client).post<VotingPolicyVotingPoliciesSearchCreateResponses, unknown, ThrowOnError>({
    responseTransformer: votingPolicyVotingPoliciesSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-policy/voting-policies/search/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Upsert a voting recommendation confidence score
 *
 * Creates or replaces the validation confidence score for a voting recommendation version. The confidence score must be between 0.0 and 1.0. Returns 201 when a new score is created and 200 when an existing score is updated.
 */
export const votingPolicyVotingRecommendationConfidenceScoresUpdate = <ThrowOnError extends boolean = false>(
  options: Options<VotingPolicyVotingRecommendationConfidenceScoresUpdateData, ThrowOnError>
) =>
  (options.client ?? client).put<
    VotingPolicyVotingRecommendationConfidenceScoresUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseTransformer: votingPolicyVotingRecommendationConfidenceScoresUpdateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-policy/voting-recommendation-confidence-scores/{version_id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
